import domain from "@/util/domain";
const themes = {
  // THEME SYS (TEMPLATE)
  sysbet: {
    // Main Color: (mandatory)
    colorDominant: "#2D3C48",
    // AppBar Color:
    colorAppBar: "#2D3C48",
    colorTabs: "#2D3C48",
    carouselbg: "212121",
    // MenuLeft Color: (opcional) set gradient or equal colors
    colorMenuLeft: {
      base: "#2D3C48",
      darken1: "#06070b", // tom mais escuro
    },
    // App Bg Color: (mandatory) set gradient or equal colors
    colorMainAppbg: {
      base: "#171e25",
      darken1: "#06070b", // tom mais escuro
    },
    // Tables Colors:
    // colorToolBarSports: '#2D3C48', // opcional
    // colorToolBarMarkets: '#2D3C48', // opcional
    colorBreadcrumbs: "#2D3C48", // opcional
    // colorTable: '#000', // opcional
    // colorOddText:'#FFC107',
    colorOddSelected: {
      // (mandatory) set gradient or equal colors
      base: "#FFFFFF",
      darken1: "#FFFFFF", // tom mais escuro
    },
    colorOddSelectedBorder: "#FFFFFF", // (mandatory)
    colorOddSelectedText: "#F64B20", // (mandatory)
    // Default Framework
    primary: "#F64B20", // opcional
    accent: "#FFC107", // opcional (ex. )
    // secondary: '#424242',  // opcional
    // error: '#FF5252', // opcional
    // info: '#2196F3', // opcional
    // success: '#4CAF50', // opcional
    // warning: '#FFC107', // opcional
  },
  homolog: {
    // Main Color: (mandatory)
    colorDominant: "#2D3C48",
    // AppBar Color:
    colorAppBar: "#2D3C48",
    colorTabs: "#2D3C48",
    // MenuLeft Color: (opcional) set gradient or equal colors
    colorMenuLeft: {
      base: "#2D3C48",
      darken1: "#06070b", // tom mais escuro
    },
    // App Bg Color: (mandatory) set gradient or equal colors
    colorMainAppbg: {
      base: "#171e25",
      darken1: "#06070b", // tom mais escuro
    },
    // Tables Colors:
    // colorToolBarSports: '#2D3C48', // opcional
    // colorToolBarMarkets: '#2D3C48', // opcional
    colorBreadcrumbs: "#2D3C48", // opcional
    // colorTable: '#000', // opcional
    // colorOddText:'#FFC107',
    colorOddSelected: {
      // (mandatory) set gradient or equal colors
      base: "#FFFFFF",
      darken1: "#FFFFFF", // tom mais escuro
    },
    colorOddSelectedBorder: "#FFFFFF", // (mandatory)
    colorOddSelectedText: "#F64B20", // (mandatory)
    // Default Framework
    primary: "#F64B20", // opcional
    accent: "#FFC107", // opcional (ex. )
    // secondary: '#424242',  // opcional
    // error: '#FF5252', // opcional
    // info: '#2196F3', // opcional
    // success: '#4CAF50', // opcional
    // warning: '#FFC107', // opcional
  },

  // IMPERIALBET.bet
  imperialbet: {
    colorDominant: "#282828",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#b4742f",
      darken1: "#000000",
    },
    colorMainAppbg: {
      base: "#212121",
      darken1: "#080809",
    },
    colorBreadcrumbs: "#212121",
    colorOddSelected: {
      base: "#f4e96e",
      darken1: "#fae748",
    },
    colorOddSelectedBorder: "#F9A825",
    colorOddSelectedText: "#000000",

    primary: "#FFA000",
    accent: "#fae748",
  },
  // IMPERIALBET.com
  imperialbetcom: {
    colorDominant: "#313131",
    colorAppBar: "#212121",
    colorTabs: "#212121",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#666666",
      darken1: "#222222",
    },
    colorMainAppbg: {
      base: "#414141",
      darken1: "#414141",
    },
    colorBreadcrumbs: "#313131",
    colorOddSelected: {
      base: "#f4e96e",
      darken1: "#fae748",
    },
    colorOddSelectedBorder: "#F9A825",
    colorOddSelectedText: "#000000",
    colorOddText: "#ffffff",
    primary: "#ffc400",
    accent: "#fae748",
  },

  // CARTOLA
  cartola: {
    colorDominant: "#2D3C48",
    colorAppBar: "#2D3C48",
    colorTabs: "#2D3C48",
    colorMenuLeft: {
      base: "#2D3C48",
      darken1: "#06070b",
    },
    colorMainAppbg: {
      base: "#171e25",
      darken1: "#06070b",
    },
    colorBreadcrumbs: "#171e25",
    colorOddSelected: {
      base: "#FFFFFF",
      darken1: "#FFFFFF",
    },
    colorOddSelectedBorder: "#FFFFFF",
    colorOddSelectedText: "#6eaf2d",
    primary: "#6eaf2d",
    accent: "#FFC107",
  },

  // SHOWBET
  showbet: {
    colorDominant: "#212121",
    colorAppBar: "#7f0000",
    colorTabs: "#7f0000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#7f0000",
      darken1: "#000000",
    },
    colorMainAppbg: {
      base: "#1a0900",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#1a0900",
    // colorOddText: '#FFFF00',
    colorOddSelected: {
      base: "#FFFF00",
      darken1: "#FFEA00",
    },
    colorOddSelectedBorder: "#b33f00",
    colorOddSelectedText: "#000000",
    primary: "#ffa200",
    accent: "#FFFF00",
  },

  // CHUTAÇO
  chutaco: {
    colorDominant: "#2d482e",
    colorAppBar: "#0e390e",
    colorTabs: "#0e390e",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#04531a",
      darken1: "#000d04",
    },
    colorMainAppbg: {
      base: "#01260b",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#01260b",
    // colorOddText: '#FFFF00',
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#cccccc",
    },
    colorOddSelectedBorder: "#2d482e",
    colorOddSelectedText: "#000000",
    primary: "#2cb42c",
    accent: "#FFFF00",
  },

  // BET69VIP
  bet69vip: {
    colorDominant: "#071f41",
    colorAppBar: "#04142a",
    colorTabs: "#04142a",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#0e4086",
      darken1: "#020913",
    },
    colorOddText: "#ff6600",
    colorOddSelected: {
      base: "#ff6600",
      darken1: "#ff6600",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#ffffff",
    colorMainAppbg: {
      base: "#020913",
      darken1: "#000000",
    },
    primary: "#ff6600",
    accent: "#fae748",
  },

  // BOLLA NA REDE
  bollanarede: {
    colorDominant: "#222222",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#ed3237",
      darken1: "#000000",
    },
    colorMainAppbg: {
      base: "#333333",
      darken1: "#111111",
    },
    colorBreadcrumbs: "#141414",
    colorOddSelected: {
      base: "#FFFFFF",
      darken1: "#FFFFFF",
    },
    colorOddSelectedBorder: "#ed3237",
    colorOddSelectedText: "#000000",
    primary: "#ed3237",
    accent: "#ede632",
  },

  // OURO DA SORTE
  ourodasorte: {
    colorDominant: "#003300",
    colorAppBar: "#006600",
    colorTabs: "#006600",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#baa700",
      darken1: "#001a00",
    },
    colorMainAppbg: {
      base: "#003300",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#001a00",
    colorOddSelected: {
      base: "#ffff00",
      darken1: "#ffff00",
    },
    colorOddSelectedBorder: "#877a00",
    colorOddSelectedText: "#000000",
    primary: "#edd500",
    accent: "#ede632",
  },
  // OURO DA SORTE SPORTS
  ourodasortesports: {
    colorDominant: "#003300",
    colorAppBar: "#006600",
    colorTabs: "#006600",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#baa700",
      darken1: "#001a00",
    },
    colorMainAppbg: {
      base: "#003300",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#001a00",
    colorOddSelected: {
      base: "#ffff00",
      darken1: "#ffff00",
    },
    colorOddSelectedBorder: "#877a00",
    colorOddSelectedText: "#000000",
    primary: "#edd500",
    accent: "#ede632",
  },

  // Live Sports Bet
  livesportsbet: {
    colorDominant: "#021f3d",
    colorAppBar: "#05386f",
    colorTabs: "#05386f",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#086ad0",
      darken1: "#011224",
    },
    colorMainAppbg: {
      base: "#04386e",
      darken1: "#00060c",
    },
    colorBreadcrumbs: "#021f3d",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#d9ebfe",
    },
    colorOddSelectedBorder: "#d9ebfe",
    colorOddSelectedText: "#000000",
    primary: "#f22828",
    accent: "#ede632",
  },

  // 90Sports
  "90sports": {
    colorDominant: "#12541f",
    colorAppBar: "#2b6329",
    colorTabs: "#2b6329",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#ddb444",
      darken1: "#503b12",
    },
    colorMainAppbg: {
      base: "#12541f",
      darken1: "#193c0a",
    },
    colorBreadcrumbs: "#193c0a",
    colorOddSelected: {
      base: "#f9d757",
      darken1: "#f9d757",
    },
    colorOddSelectedBorder: "#877a00",
    colorOddSelectedText: "#000000",
    primary: "#c89725",
    accent: "#ede632",
  },

  playesportes: {
    colorDominant: "#032441",
    colorAppBar: "#032441",
    colorTabs: "#032441",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#da3309",
      darken1: "#032441",
    },
    colorMainAppbg: {
      base: "#085aa2",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#043159",
    colorOddSelected: {
      base: "#f9df44",
      darken1: "#f9df44",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#000000",
    primary: "#da3309", // opcional
    accent: "#FFC107",
  },

  rbetsvip: {
    colorDominant: "#02032c",
    colorAppBar: "#02032c",
    colorTabs: "#02032c",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#080ba6",
      darken1: "#02032c",
    },
    colorMainAppbg: {
      base: "#050875",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#02032c",
    colorOddSelected: {
      base: "#ffde00",
      darken1: "#b39b00",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#000000",
    primary: "#ccb200",
    accent: "#c3ae00",
  },

  elitexbet: {
    colorDominant: "#1d5434",
    colorAppBar: "#145c33",
    colorTabs: "#145c33",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#c0b22d",
      darken1: "#145c33",
    },
    colorMainAppbg: {
      base: "#164128",
      darken1: "#102e1d",
    },
    colorBreadcrumbs: "#145c33",
    colorOddSelected: {
      base: "#ffd60a",
      darken1: "#ffd60a",
    },
    colorOddSelectedBorder: "#f2c417",
    colorOddSelectedText: "#000000",
    colorOddText: '#ffd60a',
    primary: "#cfbd1e",
    accent: "#ffd60a",
  },

  elitexbetvip: {
    colorDominant: "#1d5434",
    colorAppBar: "#145c33",
    colorTabs: "#145c33",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#c0b22d",
      darken1: "#145c33",
    },
    colorMainAppbg: {
      base: "#164128",
      darken1: "#102e1d",
    },
    colorBreadcrumbs: "#145c33",
    colorOddSelected: {
      base: "#ffd60a",
      darken1: "#ffd60a",
    },
    colorOddSelectedBorder: "#f2c417",
    colorOddSelectedText: "#000000",
    colorOddText: '#ffd60a',
    primary: "#cfbd1e",
    accent: "#ffd60a",
  },

  elitexbetcom: {
    colorDominant: "#1d5434",
    colorAppBar: "#145c33",
    colorTabs: "#145c33",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#c0b22d",
      darken1: "#145c33",
    },
    colorMainAppbg: {
      base: "#164128",
      darken1: "#102e1d",
    },
    colorBreadcrumbs: "#145c33",
    colorOddSelected: {
      base: "#ffd60a",
      darken1: "#ffd60a",
    },
    colorOddSelectedBorder: "#f2c417",
    colorOddSelectedText: "#000000",
    colorOddText: '#ffd60a',
    primary: "#cfbd1e",
    accent: "#ffd60a",
  },
  elitexbetnet: {
    colorDominant: "#1d5434",
    colorAppBar: "#145c33",
    colorTabs: "#145c33",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#c0b22d",
      darken1: "#145c33",
    },
    colorMainAppbg: {
      base: "#164128",
      darken1: "#102e1d",
    },
    colorBreadcrumbs: "#145c33",
    colorOddSelected: {
      base: "#ffd60a",
      darken1: "#ffd60a",
    },
    colorOddSelectedBorder: "#f2c417",
    colorOddSelectedText: "#000000",
    colorOddText: '#ffd60a',
    primary: "#cfbd1e",
    accent: "#ffd60a",
  },

  apostamaster: {
    colorDominant: "#202020",
    colorAppBar: "#000000",
    colorTabs: "#06070b",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#e6c900",
      darken1: "#000000",
    },
    colorOddText: "#ffdf00",
    colorOddSelected: {
      base: "#2c2c2c",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#2c2c2c",
    colorOddSelectedBorder: "#ffdf00",
    colorOddSelectedText: "#ffffff",
    colorMainAppbg: {
      base: "#212121",
      darken1: "#080809",
    },
    primary: "#e6c900",
    accent: "#ffdf00",
  },

  sortesuabet: {
    colorDominant: "#003d58",
    colorAppBar: "#003d58",
    colorTabs: "#003d58",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#007c96",
      darken1: "#002c3f",
    },
    colorOddText: "#ff5617",
    colorOddSelected: {
      base: "#c52e1e",
      darken1: "#c52e1e",
    },
    colorBreadcrumbs: "#002c3f",
    colorOddSelectedBorder: "#ff5617",
    colorOddSelectedText: "#ffffff",
    colorMainAppbg: {
      base: "#212121",
      darken1: "#080809",
    },
    primary: "#ff5617",
    accent: "#ffd60a",
  },

  realxapostas: {
    colorDominant: "#242f79",
    colorAppBar: "#242f79",
    colorTabs: "#242f79",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#b36f11",
      darken1: "#b36f11",
    },
    colorMainAppbg: {
      base: "#313131",
      darken1: "#262626",
    },
    colorBreadcrumbs: "#2c2c2c",
    colorOddSelected: {
      base: "#ffc42c",
      darken1: "#ffc42c",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#000000",
    primary: "#fe9e38",
    accent: "#d0b029",
  },

  golfutbet: {
    colorDominant: "#2d4c75",
    colorAppBar: "#2d4c75",
    colorTabs: "#2d4c75",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#b5451b",
      darken1: "#732b11",
    },
    colorMainAppbg: {
      base: "#313131",
      darken1: "#262626",
    },
    colorTable: "#1f3550",
    colorOddSelected: {
      base: "#df5724",
      darken1: "#df5724",
    },
    colorOddSelectedBorder: "#df5724",
    colorOddSelectedText: "#ffffff",
    primary: "#df5724",
    accent: "#fcff00",
  },

  betinterativo: {
    colorDominant: "#1f456b",
    colorAppBar: "#1f456b",
    colorTabs: "#1f456b",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#cf5f01",
      darken1: "#cf5f01",
    },
    colorMainAppbg: {
      base: "#313131",
      darken1: "#262626",
    },
    colorBreadcrumbs: "#1f456b",
    colorOddSelected: {
      base: "#fe9238",
      darken1: "#fe9238",
    },
    colorOddSelectedBorder: "#df5724",
    colorOddSelectedText: "#ffffff",
    primary: "#fe9238",
    accent: "#fcff00",
  },

  betinterativovip: {
    colorDominant: "#1f456b",
    colorAppBar: "#1f456b",
    colorTabs: "#1f456b",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#cf5f01",
      darken1: "#cf5f01",
    },
    colorMainAppbg: {
      base: "#313131",
      darken1: "#262626",
    },
    colorBreadcrumbs: "#1f456b",
    colorOddSelected: {
      base: "#fe9238",
      darken1: "#fe9238",
    },
    colorOddSelectedBorder: "#df5724",
    colorOddSelectedText: "#ffffff",
    primary: "#fe9238",
    accent: "#fcff00",
  },

  girosbet: {
    colorDominant: "#333333",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#ff0000",
      darken1: "#1a0000",
    },
    colorMainAppbg: {
      base: "#313131",
      darken1: "#262626",
    },
    colorBreadcrumbs: "#313131",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ff0000",
    colorOddSelectedText: "#000000",
    primary: "#ff0000",
    accent: "#fcff00",
  },

  betgol: {
    colorDominant: "#333333",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#ff4a07",
      darken1: "#872400",
    },
    colorMainAppbg: {
      base: "#313131",
      darken1: "#262626",
    },
    colorBreadcrumbs: "#313131",
    colorOddSelected: {
      base: "#ff4a07",
      darken1: "#ff4a07",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#ffffff",
    primary: "#ff5d21",
    accent: "#ff703a",
  },

  intocaveis: {
    colorDominant: "#333333",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#f47212",
      darken1: "#502404",
    },
    colorMainAppbg: {
      base: "#313131",
      darken1: "#262626",
    },
    colorBreadcrumbs: "#313131",
    colorOddSelected: {
      base: "#fa710c",
      darken1: "#fa710c",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#000000",
    primary: "#f47212",
    accent: "#fcff00",
  },

  chutedasorte: {
    colorDominant: "#1b1b1b",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#4ac10a",
      darken1: "#000000",
    },
    colorMainAppbg: {
      base: "#303030",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#303030",
    colorOddSelected: {
      base: "#4ac10a",
      darken1: "#4ac10a",
    },
    colorOddSelectedBorder: "#fefefe",
    colorOddSelectedText: "#000000",
    primary: "#4ac10a",
    accent: "#fec226",
  },
  superbetsapp: {
    colorDominant: "#414141",
    colorAppBar: "#353535",
    colorTabs: "#353535",
    carouselbg: "#353535",
    colorMenuLeft: {
      base: "#414141",
      darken1: "#212121",
    },
    colorMainAppbg: {
      base: "#4c4c4f",
      darken1: "#4c4c4f",
    },
    colorToolBarMarkets: "#333333", // opcional
    colorTable: "#333333", // opcional
    colorBreadcrumbs: "#353535",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#000000",
    colorOddText: '#F7EC07',
    primary: "#F7EC07",
    accent: "#FFDF1b",
  },
  b1: {
    colorDominant: "#222222",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#f5822d",
      darken1: "#000000",
    },
    colorMainAppbg: {
      base: "#333333",
      darken1: "#111111",
    },
    colorBreadcrumbs: "#141414",
    colorOddSelected: {
      base: "#f5822d",
      darken1: "#f5822d",
    },
    colorOddSelectedBorder: "#FFC400",
    colorOddSelectedText: "#ffffff",
    primary: "#f5822d",
    accent: "#ede632",
  },

  smilebetnet: {
    colorDominant: "#351400",
    colorAppBar: "#351400",
    colorTabs: "#351400",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#feb700",
      darken1: "#682700",
    },
    colorMainAppbg: {
      base: "#682700",
      darken1: "#000000",
    },
    // colorBreadcrumbs: '#212121',
    colorOddSelected: {
      base: "#feb700",
      darken1: "#feb700",
    },
    // colorOddText: '#FFA000',
    colorOddSelectedBorder: "#F9A825",
    colorOddSelectedText: "#000000",
    primary: "#feb700",
    accent: "#fae748",
  },

  sportsdarodada: {
    colorDominant: "#222222",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#ff0000",
      darken1: "#000000",
    },
    colorMainAppbg: {
      base: "#333333",
      darken1: "#111111",
    },
    colorBreadcrumbs: "#141414",
    colorOddSelected: {
      base: "#FFFFFF",
      darken1: "#FFFFFF",
    },
    colorOddSelectedBorder: "#ff0000",
    colorOddSelectedText: "#000000",
    primary: "#ff0000",
    accent: "#ede632",
  },

  confiancasports: {
    colorDominant: "#282828",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#ff0000",
      darken1: "#121212",
    },
    colorMainAppbg: {
      base: "#383838",
      darken1: "#121212",
    },
    colorOddSelected: {
      base: "#FFFFFF",
      darken1: "#FFFFFF",
    },
    colorOddSelectedBorder: "#f05545",
    colorOddSelectedText: "#000000",
    primary: "#ff0000",
    accent: "#ffffff",
  },

  jogodeourobet: {
    colorDominant: "#11400a",
    colorAppBar: "#011906",
    colorTabs: "#011906",
    carouselbg: "11400a",
    colorMenuLeft: {
      base: "#11400a",
      darken1: "#001a00",
    },
    colorMainAppbg: {
      base: "#11400a",
      darken1: "#000000",
    },
    colorOddSelected: {
      base: "#f9ff00",
      darken1: "#f9ff00",
    },
    colorOddSelectedBorder: "#f9ff00",
    colorOddSelectedText: "#00431f",
    colorOddText: '#f9ff00',
    primary: "#00d43c",
    accent: "#f9ff00",
  },

  apostesempre: {
    colorDominant: "#192229",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#00cc52",
      darken1: "#06070b",
    },
    colorMainAppbg: {
      base: "#171e25",
      darken1: "#06070b",
    },
    colorBreadcrumbs: "#171e25",
    colorOddSelected: {
      base: "#00ff66",
      darken1: "#00ff66",
    },
    colorOddSelectedBorder: "#FFFFFF",
    colorOddSelectedText: "#000000",
    primary: "#00cc52",
    accent: "#00ff66",
  },

  a3bet: {
    colorDominant: "#042949",
    colorAppBar: "#042949",
    colorTabs: "#042949",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#083864",
      darken1: "#083864",
    },
    colorMainAppbg: {
      base: "#083864",
      darken1: "#083864",
    },
    colorOddSelected: {
      base: "#30C88F",
      darken1: "#30C88F",
    },
    colorOddSelectedBorder: "#30C88F",
    colorOddSelectedText: "#FFFFFF",
    primary: "#30C88F",
    accent: "#83B9FF",
  },

  apostador: {
    colorDominant: "#282828",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#ff0000",
      darken1: "#121212",
    },
    colorMainAppbg: {
      base: "#383838",
      darken1: "#121212",
    },
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#f05545",
    colorOddSelectedText: "#000000",
    primary: "#ff0000",
    accent: "#ffffff",
  },

  bets88: {
    colorDominant: "#20222F",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#FF5302",
      darken1: "#000000",
    },
    colorMainAppbg: {
      base: "#000000",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#000000",
    colorOddSelected: {
      base: "#FF5302",
      darken1: "#FF5302",
    },
    colorOddSelectedBorder: "#FF5302",
    colorOddSelectedText: "#FFFFFF",
    colorOddText: "#FF5302",
    primary: "#FF5302",
    accent: "#E040FB",
  },

  spinbet: {
    colorDominant: "#333333",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#ff0000",
      darken1: "#1a0000",
    },
    colorMainAppbg: {
      base: "#313131",
      darken1: "#262626",
    },
    colorBreadcrumbs: "#313131",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ff0000",
    colorOddSelectedText: "#000000",
    primary: "#ff0000",
    accent: "#fcff00",
  },

  "8bets": {
    colorDominant: "#0e0c0c",
    colorAppBar: "#0e0c0c",
    colorTabs: "#0e0c0c",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#04D3FF",
      darken1: "#0e0c0c",
    },
    colorMainAppbg: {
      base: "#0e0c0c",
      darken1: "#000000",
    },
    // colorBreadcrumbs: '#04386e',
    colorOddSelected: {
      base: "#04D3FF",
      darken1: "#04D3FF",
    },
    colorOddSelectedBorder: "#04D3FF",
    colorOddSelectedText: "#000000",
    colorOddText: "#50E0FF",
    primary: "#04D3FF",
    accent: "#04D3FF",
  },
  palpitenarede: {
    colorDominant: "#4c4947",
    colorAppBar: "#171616",
    colorTabs: "#171616",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#b45100",
      darken1: "#171616",
    },
    colorMainAppbg: {
      base: "#313131",
      darken1: "#313131",
    },
    colorBreadcrumbs: "#3f3c3b",
    colorOddSelected: {
      base: "#e76800",
      darken1: "#e76800",
    },
    colorOddSelectedBorder: "#cd5d00",
    colorOddSelectedText: "#ffffff",
    primary: "#eb6b34",
    accent: "#ffffff",
  },
  betprime: {
    colorDominant: "#49494d",
    colorAppBar: "#1b0b40",
    colorTabs: "#1b0b40",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#7bcc03",
      darken1: "#1b0b40",
    },
    colorMainAppbg: {
      base: "#3d3d40",
      darken1: "#3d3d40",
    },
    colorBreadcrumbs: "#353639",
    colorOddSelected: {
      base: "#6cb302",
      darken1: "#6cb302",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#ffffff",
    primary: "#8ae503",
    accent: "#8ae503",
  },
  cabradabet: {
    colorDominant: "#404040",
    colorAppBar: "#1a1a1a",
    colorTabs: "#1a1a1a",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#f34c27",
      darken1: "#1a1a1a",
    },
    colorMainAppbg: {
      base: "#3d3d40",
      darken1: "#1a1a1a",
    },
    colorBreadcrumbs: "#353639",
    colorOddSelected: {
      base: "#F27405",
      darken1: "#F2380F",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#ffffff",
    primary: "#f34c27 ",
    accent: "#ede632",
  },
  megasorte: {
    colorDominant: "#233540",
    colorAppBar: "#233540",
    colorTabs: "#2c4350",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#F27B35",
      darken1: "#233540",
    },
    colorMainAppbg: {
      base: "#111a1f",
      darken1: "#111a1f",
    },
    colorBreadcrumbs: "#233540",
    colorOddSelected: {
      base: "#f59a65",
      darken1: "#F27B35",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#ffffff",
    primary: "#f06b1d ",
    accent: "#ede632",
  },
  popbet: {
    colorDominant: "#181866",
    colorAppBar: "#131351",
    colorTabs: "#181866",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#015c54",
      darken1: "#181866",
    },
    colorMainAppbg: {
      base: "#02756b",
      darken1: "#181866",
    },
    // colorBreadcrumbs: '#233540',
    colorOddSelected: {
      base: "#02a898",
      darken1: "#02a898",
    },
    colorOddSelectedBorder: "#02a898",
    colorOddSelectedText: "#131351",
    colorOddText: "#FFAC00",
    primary: "#03dac6 ",
    accent: "#03dac6",
  },
  looksports: {
    colorDominant: "#1f2647",
    colorAppBar: "#0d1a59",
    colorTabs: "#0d1a59",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#c5881d",
      darken1: "#13133e",
    },
    colorMainAppbg: {
      base: "#2e3038",
      darken1: "#010519",
    },
    colorOddSelected: {
      base: "#c5881d",
      darken1: "#c5881d",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#ffffff",
    primary: "#c5881d ",
    accent: "#feee9a",
  },
  unicabet: {
    colorDominant: "#396f37",
    colorAppBar: "#023b01",
    colorTabs: "#023b01",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#fa6801",
      darken1: "#024000",
    },
    colorMainAppbg: {
      base: "#1d5434",
      darken1: "#023b01",
    },
    colorOddSelected: {
      base: "#f96e01",
      darken1: "#f96e01",
    },
    colorOddSelectedBorder: "#f96e01",
    colorOddSelectedText: "#ffffff",
    primary: "#f96e01",
    accent: "#f87601",
  },
  amabet: {
    colorDominant: "#1a214d",
    colorAppBar: "#253278",
    colorTabs: "#253278",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#a17623",
      darken1: "#1a214d",
    },
    colorMainAppbg: {
      base: "#1a214d",
      darken1: "#0D0D0D",
    },
    colorOddSelected: {
      base: "#d4a03d",
      darken1: "#d4a03d",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#2d3a86",
    primary: "#cb942d ",
    accent: "#D9AA52",
  },
  // sportsbet765: {
  //   colorDominant: "#1a5488",
  //   colorAppBar: "#123a5e",
  //   colorTabs: "#123a5e",
  //   carouselbg: "212121",
  //   colorMenuLeft: {
  //     base: "#164773",
  //     darken1: "#0e2c48",
  //   },
  //   colorMainAppbg: {
  //     base: "#192228",
  //     darken1: "#010602",
  //   },
  //   colorOddSelected: {
  //     base: "#f3c22e",
  //     darken1: "#f3c22e",
  //   },
  //   colorOddSelectedBorder: "#104459",
  //   colorOddSelectedText: "#104459",
  //   primary: "#f2bb16",
  //   accent: "#eeb03d",
  // },
  betclub7: {
    colorDominant: "#212121",
    colorAppBar: "#111111",
    colorTabs: "#111111",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#199738",
      darken1: "#111111",
    },
    colorMainAppbg: {
      base: "#424242",
      darken1: "#212121",
    },
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#76ff03",
    colorOddSelectedText: "#168130",
    colorOddText: "#ffffff",
    primary: "#199738",
    accent: "#76ff03",
  },
  espetbet: {
    colorDominant: "#000000",
    colorAppBar: "#000000",
    colorTabs: "#333335",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#6e1111",
      darken1: "#6e1111",
    },
    colorMainAppbg: {
      base: "#000000",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#333335",
    colorOddSelected: {
      base: "#fafafa",
      darken1: "#fafafa",
    },
    colorOddSelectedBorder: "#f22d3d",
    colorOddSelectedText: "#000000",
    primary: "#f22d3d",
    accent: "#ffff00",
  },
  viapix: {
    colorDominant: "#353535",
    colorAppBar: "#011D0D",
    colorTabs: "#011D0D",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#044D24",
      darken1: "#000402",
    },
    colorMainAppbg: {
      base: "#020202",
      darken1: "#000402",
    },
    colorBreadcrumbs: "#0f0f0f",
    colorOddSelected: {
      base: "#a2fac8",
      darken1: "#a2fac8",
    },
    colorOddText: "#a2fac8",
    colorOddSelectedBorder: "#0cde67",
    colorOddSelectedText: "#000000",
    primary: "#0cde67",
    accent: "#ffff00",
  },
  bettoro: {
    colorDominant: "#424242",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#00cd5f",
      darken1: "#06070b",
    },
    colorMainAppbg: {
      base: "#424242",
      darken1: "#06070b",
    },
    colorBreadcrumbs: "#424242",
    colorOddSelected: {
      base: "#00cd5f",
      darken1: "#00cd5f",
    },
    colorOddSelectedBorder: "#00cd5f",
    colorOddSelectedText: "#ffffff",
    primary: "#00cd5f",
    accent: "#00cd5f",
  },
  sportshowpix: {
    colorDominant: "#606060",
    colorAppBar: "#126E51",
    colorTabs: "#126E51",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#1D1D1D",
      darken1: "#1D1D1D",
    },
    colorMainAppbg: {
      base: "#59585D",
      darken1: "#59585D",
    },
    colorOddSelected: {
      base: "#FFDE00",
      darken1: "#FFDE00",
    },
    colorOddSelectedBorder: "#FFDE00",
    colorOddSelectedText: "#175133",
    colorOddText:'#FFDE00',
    primary: "#24DBA2",
    accent: "#FFFF00",
  },
  condutaesportiva: {
    colorDominant: "#175133",
    colorAppBar: "#006732",
    colorTabs: "#006732",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#beb522",
      darken1: "#006732",
    },
    colorMainAppbg: {
      base: "#424242",
      darken1: "#282828",
    },
    colorOddSelected: {
      base: "#ffd600",
      darken1: "#ffd600",
    },
    colorOddSelectedBorder: "#FFFFFF",
    colorOddSelectedText: "#00351a",
    primary: "#beb522",
    accent: "#02ff7e",
  },
  betpremier: {
    colorDominant: "#123454",
    colorAppBar: "#003566",
    colorTabs: "#003566",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#ffc300",
      darken1: "#00284d",
    },
    colorBreadcrumbs: "#00284d",
    colorMainAppbg: {
      base: "#424242",
      darken1: "#001a33",
    },
    colorOddSelected: {
      base: "#ffc300",
      darken1: "#ffc300",
    },
    colorOddSelectedBorder: "#FFFFFF",
    colorOddSelectedText: "#001935",
    primary: "#e6b000",
    accent: "#02ff7e",
  },
  maisbet: {
    colorDominant: "#212121",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#fdd835",
      darken1: "#000000",
    },
    colorMainAppbg: {
      base: "#59595c",
      darken1: "#303030",
    },
    colorBreadcrumbs: "#212121",
    colorOddSelected: {
      base: "#fbc02d",
      darken1: "#fbc02d",
    },
    // colorOddText: '#FFA000',
    colorOddSelectedBorder: "#fbc02d",
    colorOddSelectedText: "#000000",
    primary: "#fbc02d",
    accent: "#76ff03",
  },
  idj: {
    colorDominant: "#122c67",
    colorAppBar: "#16367c",
    colorTabs: "#16367c",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#ffc107",
      darken1: "#0e2351",
    },
    colorBreadcrumbs: "#0e2351",
    colorMainAppbg: {
      base: "#4e535e",
      darken1: "#030710",
    },
    colorOddSelected: {
      base: "#fcb040",
      darken1: "#fcb040",
    },
    colorOddSelectedBorder: "#fcb040",
    colorOddSelectedText: "#001935",
    primary: "#E6B000",
    accent: "#02FF7E",
  },
  forrabet: {
    colorDominant: "#212121",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#e26500",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#111111",
    colorMainAppbg: {
      base: "#424242",
      darken1: "#212121",
    },
    colorOddSelected: {
      base: "#e26500",
      darken1: "#e26500",
    },
    colorOddSelectedBorder: "#e26500",
    colorOddSelectedText: "#000000",
    primary: "#e26500",
    accent: "#fff000",
  },
  socialbet: {
    colorDominant: "#212121",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#ff7e3d",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#212121",
    colorMainAppbg: {
      base: "#424242",
      darken1: "#212121",
    },
    colorOddSelected: {
      base: "#ff7e3d",
      darken1: "#ff7e3d",
    },
    colorOddSelectedBorder: "#ff7e3d",
    colorOddSelectedText: "#000000",
    primary: "#ff7e3d",
    accent: "#fff000",
  },
  betcartola: {
    colorDominant: "#006481",
    colorAppBar: "#1e647f",
    colorTabs: "#1e647f",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#000000",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#212121",
    colorMainAppbg: {
      base: "#2b2b2b",
      darken1: "#2b2b2b",
    },
    colorOddSelected: {
      base: "#00ff67",
      darken1: "#00ff67",
    },
    colorOddSelectedBorder: "#00ff67",
    colorOddSelectedText: "#000000",
    primary: "#00e65d",
    accent: "#00ff67",
  },
  faz1bet: {
    colorDominant: "#313131",
    colorAppBar: "#1c1c1c",
    colorTabs: "#1c1c1c",
    carouselbg: "0AC47A",
    colorMenuLeft: {
      base: "#000000",
      darken1: "#000000",
    },
    colorMainAppbg: {
      base: "#424242",
      darken1: "#212121",
    },
    colorBreadcrumbs: "#1c1c1c",
    colorOddSelected: {
      base: "#0AC47A",
      darken1: "#0AC47A",
    },
    colorOddSelectedBorder: "#067b4d",
    colorOddSelectedText: "#ffffff",
    primary: "#0AC47A",
    accent: "#0AC47A",
  },
  betpix: {
    colorDominant: "#424242",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#a6cc00",
      darken1: "#000000",
    },
    colorMainAppbg: {
      base: "#212121",
      darken1: "#212121",
    },
    colorBreadcrumbs: "#424242",
    colorOddSelected: {
      base: "#bae600",
      darken1: "#bae600",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#000000",
    primary: "#a6cc00",
    accent: "#cfff00",
  },
  bet73: {
    colorDominant: "#404040",
    colorAppBar: "#1d1d1b",
    colorTabs: "#1d1d1b",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#bc441b",
      darken1: "#000",
    },
    colorMainAppbg: {
      base: "#333333",
      darken1: "#333333",
    },
    colorBreadcrumbs: "#404040",
    colorOddSelected: {
      base: "#e0582a",
      darken1: "#e0582a",
    },
    colorOddSelectedBorder: "#e36940",
    colorOddSelectedText: "#ffffff",
    primary: "#e0582a",
    accent: "#fff500",
  },
  americanbet: {
    colorDominant: "#202043",
    colorAppBar: "#141450",
    colorTabs: "#141450",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#991212",
      darken1: "#270404",
    },
    colorMainAppbg: {
      base: "#0a0a27",
      darken1: "#050513",
    },
    colorBreadcrumbs: "#202043",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#0a0a27",
    primary: "#dd1a1a",
    accent: "#ede632",
  },
  esportivabet: {
    colorDominant: "#333333",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#fc5a53",
      darken1: "#000000",
    },
    colorMainAppbg: {
      base: "#404040",
      darken1: "#404040 ",
    },
    colorBreadcrumbs: "#333333",
    colorOddSelected: {
      base: "#fc5b53",
      darken1: "#fc5b53",
    },
    colorOddSelectedBorder: "#fc5b53",
    colorOddSelectedText: "#fff",
    primary: "#fc5b53",
    accent: "#ff6f00",
  },
  betclassea: {
    colorDominant: "#333333",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#3fa000",
      darken1: "#d67105",
    },
    colorMainAppbg: {
      base: "#171717",
      darken1: "#171717 ",
    },
    colorBreadcrumbs: "#333333",
    colorOddSelected: {
      base: "#87ff3a",
      darken1: "#87ff3a",
    },
    colorOddSelectedBorder: "#87ff3a",
    colorOddSelectedText: "#000000",
    primary: "#fa922a",
    accent: "#fa952c",
  },
  pokarbet: {
    colorDominant: "#001848",
    colorAppBar: "#002061",
    colorTabs: "#002061",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#fd6500",
      darken1: "#001848",
    },
    colorMainAppbg: {
      base: "#3d3d40",
      darken1: "#1a1a1a",
    },
    colorBreadcrumbs: "#333333",
    colorOddSelected: {
      base: "#fd6500",
      darken1: "#fd6500",
    },
    colorOddSelectedBorder: "#fa922a",
    colorOddSelectedText: "#ffffff",
    primary: "#fd6500",
    accent: "#fa952c",
  },
  soccer888: {
    colorDominant: "#252b55",
    colorAppBar: "#252b55",
    colorTabs: "#252b55",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#1bac12",
      darken1: "#001848",
    },
    colorMainAppbg: {
      base: "#3d3d40",
      darken1: "#3d3d40",
    },
    colorBreadcrumbs: "#333333",
    colorOddSelected: {
      base: "#1bac12",
      darken1: "#1bac12",
    },
    colorOddSelectedBorder: "#1bac12",
    colorOddSelectedText: "#ffffff",
    primary: "#1bac12",
    accent: "#ffea00",
  },
  zigbet: {
    colorDominant: "#333333",
    colorAppBar: "#1a1a1a",
    colorTabs: "#1a1a1a",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#10c0c8",
      darken1: "#1a1a1a",
    },
    colorBreadcrumbs: "#212121",
    colorMainAppbg: {
      base: "#404040",
      darken1: "#404040",
    },
    colorOddSelected: {
      base: "#00ff67",
      darken1: "#00ff67",
    },
    colorOddSelectedBorder: "#00ff67",
    colorOddSelectedText: "#000000",
    primary: "#10c0c8",
    accent: "#10c0c8",
  },
  golacobet: {
    colorDominant: "#002645",
    colorAppBar: "#00182c",
    colorTabs: "#00182c",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#ff6600",
      darken1: "#00182c",
    },
    colorMainAppbg: {
      base: "#000a12",
      darken1: "#000a12",
    },
    colorBreadcrumbs: "#00182c",
    colorOddSelected: {
      base: "#ff6600",
      darken1: "#ff6600",
    },
    colorOddSelectedBorder: "#ff6600",
    colorOddSelectedText: "#ffffff",
    primary: "#ff6600 ",
    accent: "#ede632",
  },
  sortepixbet: {
    colorDominant: "#282828",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#bae62f",
      darken1: "#000000",
    },
    colorMainAppbg: {
      base: "#212121",
      darken1: "#080809",
    },
    colorBreadcrumbs: "#212121",
    colorOddSelected: {
      base: "#8db316",
      darken1: "#8db316",
    },
    colorOddText: '#bae62f',
    colorOddSelectedBorder: "#8db316",
    colorOddSelectedText: "#ffffff",
    primary: "#8db316",
    accent: "#ffff00",
  },
  pixbetbrasil: {
    colorDominant: "#333333",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#004A99",
      darken1: "#004A99",
    },
    colorBreadcrumbs: "#000000",
    colorMainAppbg: {
      base: "#333333",
      darken1: "#111111",
    },
    colorOddSelected: {
      base: "#FFEB3B",
      darken1: "#FFEB3B",
    },
    colorOddSelectedBorder: "#FFEB3B",
    colorOddSelectedText: "#001A38",
    colorOddText: '#CAE8FF',
    primary: "#64BCFF",
    accent: "#FFFF00",
  },
  pixpremioesporte: {
    colorDominant: "#1e376d",
    colorAppBar: "#004a99",
    colorTabs: "#004a99",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#40be3b",
      darken1: "#004a99",
    },
    colorBreadcrumbs: "#1e376d",
    colorMainAppbg: {
      base: "#212121",
      darken1: "#080809",
    },
    colorOddSelected: {
      base: "#00931e",
      darken1: "#00931e",
    },
    colorOddSelectedBorder: "#76ff03",
    colorOddSelectedText: "#ffffff",
    colorOddText: '#76ff03',
    primary: "#64dd17",
    accent: "#ffff00",
  },
  betcerta: {
    colorDominant: "#212121",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#57d100",
      darken1: "#212121",
    },
    colorMainAppbg: {
      base: "#4c4c4f",
      darken1: "#212121",
    },
    colorBreadcrumbs: "#212121",
    colorOddSelected: {
      base: "#4db800",
      darken1: "#4db800",
    },
    colorOddSelectedBorder: "#62eb00",
    colorOddSelectedText: "#ffffff",
    colorOddText: '#62eb00',
    primary: "#57d100",
    accent: "#57d100",
  },
  bocaobet: {
    colorDominant: "#222222",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#ff3a05",
      darken1: "#000000",
    },
    colorMainAppbg: {
      base: "#404040",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#141414",
    colorOddSelected: {
      base: "#d12c00",
      darken1: "#d12c00",
    },
    colorOddSelectedBorder: "#ff3a05",
    colorOddSelectedText: "#ffffff",
    colorOddText: '#ffab40',
    primary: "#ff3a05",
    accent: "#ede632",
  },
  obabet: {
    colorDominant: "#282828",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#e1a700",
      darken1: "#000000",
    },
    colorMainAppbg: {
      base: "#4c4c4f",
      darken1: "#212121",
    },
    colorBreadcrumbs: "#212121",
    colorOddSelected: {
      base: "#c79400",
      darken1: "#c79400",
    },
    colorOddSelectedBorder: "#faba00",
    colorOddSelectedText: "#ffffff",
    colorOddText: '#ffd740',
    primary: "#e1a700",
    accent: "#fae748",
  },
  tradbet: {
    colorDominant: "#212121",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#ffb400",
      darken1: "#000000",
    },
    colorMainAppbg: {
      base: "#4c4c4f",
      darken1: "#212121",
    },
    colorBreadcrumbs: "#212121",
    colorOddSelected: {
      base: "#c79400",
      darken1: "#c79400",
    },
    colorOddSelectedBorder: "#faba00",
    colorOddSelectedText: "#ffffff",
    colorOddText: '#ffd740',
    primary: "#ffb400",
    accent: "#eeff41",
  },
  sportebet: {
    colorDominant: "#212121",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#fc8e17",
      darken1: "#000000",
    },
    colorMainAppbg: {
      base: "#4c4c4f",
      darken1: "#212121",
    },
    colorBreadcrumbs: "#212121",
    colorOddSelected: {
      base: "#fc8e17",
      darken1: "#fc8e17",
    },
    colorOddSelectedBorder: "#fec100",
    colorOddSelectedText: "#ffffff",
    colorOddText: '#fec100',
    primary: "#fc8e17",
    accent: "#eeff41",
  },
  chutecertoio: {
    colorDominant: "#212121",
    colorAppBar: "#440000",
    colorTabs: "#440000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#edae05",
      darken1: "#000000",
    },
    colorMainAppbg: {
      base: "#4c4c4f",
      darken1: "#212121",
    },
    colorBreadcrumbs: "#212121",
    colorOddText: '#f2e541',
    colorOddSelected: {
      base: "#edae05",
      darken1: "#edae05",
    },
    colorOddSelectedBorder: "#f2e541",
    colorOddSelectedText: "#000000",
    primary: "#edab03",
    accent: "#FFFF00",
  },
  maiorbet: {
    colorDominant: "#212121",
    colorAppBar: "#00336e",
    colorTabs: "#00336e",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#ed1c24",
      darken1: "#000000",
    },
    colorMainAppbg: {
      base: "#4c4c4f",
      darken1: "#212121",
    },
    colorBreadcrumbs: "#212121",
    colorOddText: '#ffffff',
    colorOddSelected: {
      base: "#ed1c24",
      darken1: "#ed1c24",
    },
    colorOddSelectedBorder: "#ed1c24",
    colorOddSelectedText: "#ffffff",
    primary: "#ed1c24",
    accent: "#FFFF00",
  },
  sullbet: {
    colorDominant: "#333333",
    colorAppBar: "#1a1a1a",
    colorTabs: "#1a1a1a",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#00994d",
      darken1: "#000000",
    },
    colorMainAppbg: {
      base: "#404040",
      darken1: "#404040",
    },
    colorBreadcrumbs: "#212121",
    colorOddSelected: {
      base: "#00e673",
      darken1: "#00e673",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#000000",
    primary: "#00e673",
    accent: "#ede632",
  },
  pixbrasil: {
    colorDominant: "#004d44",
    colorAppBar: "#00332d",
    colorTabs: "#00332d",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#a2e600",
      darken1: "#00332d",
    },
    colorBreadcrumbs: "#00332d",
    colorMainAppbg: {
      base: "#4c4c4f",
      darken1: "#4c4c4f",
    },
    colorOddSelected: {
      base: "#a2e600",
      darken1: "#a2e600",
    },

    colorOddSelectedBorder: "#a2e600",
    colorOddSelectedText: "#000000",
    colorOddText: '#ffff00',
    primary: "#90cc00",
    accent: "#ffff00",
  },
  lancecerto: {
    colorDominant: "#262626",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#06c633",
      darken1: "#06070b",
    },
    colorMainAppbg: {
      base: "#262626",
      darken1: "#262626",
    },
    colorBreadcrumbs: "#262626",
    colorOddSelected: {
      base: "#06c633",
      darken1: "#06c633",
    },
    colorOddSelectedBorder: "#08f740",
    colorOddSelectedText: "#FFFFFF",
    primary: "#06c633",
    accent: "#00ff66",
  },
  mix: {
    // Model 2
    colorDominant: "#006497",
    colorAppBar: "#0086ca",
    colorTabs: "#0086ca",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#00a8fd",
      darken1: "#006497",
    },
    colorMainAppbg: {
      base: "#00537d",
      darken1: "#004264",
    },
    colorBreadcrumbs: "#0086ca",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#00314a",
    colorOddText: '#76ffff',
    primary: "#f01a08",
    accent: "#76ffff",
  },
  chutecertopro: {
    colorDominant: "#212121",
    colorAppBar: "#440000",
    colorTabs: "#440000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#000000",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#000000",
    colorMainAppbg: {
      base: "#4c4c4f",
      darken1: "#212121",
    },
    colorOddSelected: {
      base: "#edae05",
      darken1: "#edae05",
    },
    colorOddSelectedBorder: "#f2e541",
    colorOddSelectedText: "#000000",
    primary: "#edae05",
    accent: "#ffff00",
  },
  pixmaster: {
    colorDominant: "#202020",
    colorAppBar: "#000000",
    colorTabs: "#06070b",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#e6c900",
      darken1: "#000000",
    },
    colorOddText: "#ffdf00",
    colorOddSelected: {
      base: "#2c2c2c",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#2c2c2c",
    colorOddSelectedBorder: "#ffdf00",
    colorOddSelectedText: "#ffffff",
    colorMainAppbg: {
      base: "#212121",
      darken1: "#080809",
    },
    primary: "#e6c900",
    accent: "#ffdf00",
  },
  betpag: {
    colorDominant: "#005e2b",
    colorAppBar: "#005e2b",
    colorTabs: "#005e2b",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#00451f",
      darken1: "#001208",
    },
    colorMainAppbg: {
      base: "#333333",
      darken1: "#111111",
    },
    colorBreadcrumbs: "#141414",
    colorOddSelected: {
      base: "#91ffc3",
      darken1: "#91ffc3",
    },
    colorOddSelectedBorder: "#91ffc3",
    colorOddSelectedText: "#002b14",
    colorOddText: "#ffffff",
    primary: "#ffc600",
    accent: "#ffc600",
  },
  topbetsonlinecom: {
    colorDominant: "#375f3d",
    colorAppBar: "#247231",
    colorTabs: "#247231",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#ffd700",
      darken1: "#001a00",
    },
    colorMainAppbg: {
      base: "#333333",
      darken1: "#111111",
    },
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#000000",
    colorOddText: "#e6c200",
    primary: "#e6c200",
    accent: "#ffd700",
  },
  topbetslive: {
    colorDominant: "#375f3d",
    colorAppBar: "#247231",
    colorTabs: "#247231",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#ffd700",
      darken1: "#001a00",
    },
    colorMainAppbg: {
      base: "#333333",
      darken1: "#111111",
    },
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#000000",
    colorOddText: "#e6c200",
    primary: "#e6c200",
    accent: "#ffd700",
  },
  betnaveia: {
    colorDominant: "#4E335C",
    colorAppBar: "#52256A",
    colorTabs: "#52256A",
    carouselbg: "212121",
    colorBreadcrumbs: "#4F305F",
    colorMenuLeft: {
      base: "#351844",
      darken1: "#351844",
    },
    colorMainAppbg: {
      base: "#333333",
      darken1: "#111111",
    },
    colorOddSelected: {
      base: "#FFFFFF",
      darken1: "#FFFFFF",
    },
    colorOddSelectedBorder: "#FFFFFF",
    colorOddSelectedText: "#000000",
    colorOddText: "#C6FF00",
    primary: "#F37A20",
    accent: "#C6FF00",
  },
  betsuper: {
    colorDominant: "#454545",
    colorAppBar: "#001f5c",
    colorTabs: "#001f5c",
    carouselbg: "#212121",
    colorBreadcrumbs: "#333333",
    colorMenuLeft: {
      base: "#333333",
      darken1: "#333333",
    },
    colorMainAppbg: {
      base: "#212121",
      darken1: "#111111",
    },
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#000000",
    colorOddText: "#ffff00",
    primary: "#ffb400",
    accent: "#ffb400",
  },
  placarbets: {
    colorDominant: "#0178af",
    colorAppBar: "#0178af",
    colorTabs: "#0178af",
    carouselbg: "212121",
    colorBreadcrumbs: "#0178af",
    colorMenuLeft: {
      base: "#07c1f1",
      darken1: "#0e121e",
    },
    colorMainAppbg: {
      base: "#333333",
      darken1: "#0e121e",
    },
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#000000",
    colorOddText: "#ffffff",
    primary: "#07c1f1",
    accent: "#ffff00",
  },
  pingolbet: {
    colorDominant: "#333333",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorBreadcrumbs: "#050402",
    colorMenuLeft: {
      base: "#00a600",
      darken1: "#000d00",
    },
    colorMainAppbg: {
      base: "#333333",
      darken1: "#111111",
    },
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#000000",
    colorOddText: "#8dff8d",
    primary: "#00b900",
    accent: "#ffff00",
  },
  limasports: {
    colorDominant: "#212121",
    colorAppBar: "#2864e4",
    colorTabs: "#2864e4",
    carouselbg: "212121",
    colorBreadcrumbs: "#333333",
    colorMenuLeft: {
      base: "#2864e4",
      darken1: "#0a204f",
    },
    colorMainAppbg: {
      base: "#333333",
      darken1: "#111111",
    },
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#000000",
    colorOddText: "#c6d6f8",
    primary: "#82a5ef",
    accent: "#ffff00",
  },
  ddbets: {
    colorDominant: "#444444",
    colorAppBar: "#00122d",
    colorTabs: "#00122d",
    carouselbg: "212121",
    colorBreadcrumbs: "#333333",
    colorMenuLeft: {
      base: "#0053ff",
      darken1: "#00122d",
    },
    colorMainAppbg: {
      base: "#333333",
      darken1: "#111111",
    },
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#000000",
    colorOddText: "#ffc400",
    primary: "#ff8f00",
    accent: "#ffff00",
  },
  qgpix: {
    colorDominant: "#37383f",
    colorAppBar: "#141f62",
    colorTabs: "#141f62",
    carouselbg: "212121",
    colorBreadcrumbs: "#37383f",
    colorMenuLeft: {
      base: "#b2cd1c",
      darken1: "#070b22",
    },
    colorMainAppbg: {
      base: "#111111",
      darken1: "#111111",
    },
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#000000",
    colorOddText: "#c4e121",
    primary: "#b2cd1c",
    accent: "#ffff00",
  },
  cashbetbrasil: {
    colorDominant: "#444444",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorBreadcrumbs: "#37383f",
    colorMenuLeft: {
      base: "#00bd00",
      darken1: "#000000",
    },
    colorMainAppbg: {
      base: "#333333",
      darken1: "#111111",
    },
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#000000",
    colorOddText: "#00f000",
    primary: "#00d700",
    accent: "#ffff00",
  },
  centralbet: {
    colorDominant: "#212121",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorBreadcrumbs: "#212121",
    colorMenuLeft: {
      base: "#0099da",
      darken1: "#0e121e",
    },
    colorMainAppbg: {
      base: "#333333",
      darken1: "#0e121e",
    },
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#000000",
    colorOddText: "#b3d6f1",
    primary: "#0099da",
    accent: "#ffff00",
  },
  betze: {
    colorDominant: "#212121",
    colorAppBar: "#021f58",
    colorTabs: "#021f58",
    carouselbg: "212121",
    colorBreadcrumbs: "#212121",
    colorMenuLeft: {
      base: "#77db16",
      darken1: "#021f58",
    },
    colorMainAppbg: {
      base: "#333333",
      darken1: "#111111",
    },
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#000000",
    colorOddText: "#77db16",
    primary: "#77db16",
    accent: "#ffff00",
  },
  vgbet: {
    colorDominant: "#333333",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#10c0c8",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#212121",
    colorMainAppbg: {
      base: "#404040",
      darken1: "#404040",
    },
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#10c0c8",
    colorOddSelectedText: "#000000",
    colorOddText: "#00e5ff",
    primary: "#10c0c8",
    accent: "#10c0c8",
  },
  vaide: {
    colorDominant: "#222222",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#ffb000",
      darken1: "#000000",
    },
    colorMainAppbg: {
      base: "#333333",
      darken1: "#111111",
    },
    colorBreadcrumbs: "#141414",
    colorOddSelected: {
      base: "#e69e00",
      darken1: "#e69e00",
    },
    colorOddSelectedBorder: "#FFC400",
    colorOddSelectedText: "#ffffff",
    colorOddText: "#ffb000",
    primary: "#ffb000",
    accent: "#ede632",
  },
  bellosports: {
    colorDominant: "#1C1F2A",
    colorAppBar: "#FF4814",
    colorTabs: "#FF4814",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#1C1F2A",
      darken1: "#1C1F2A",
    },
    colorMainAppbg: {
      base: "#1C1F2A",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#FF4814",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#FF4814",
    colorOddText: "#FFDE90",
    primary: "#f9b616",
    accent: "#FFDE90",
  },
  paybet: {
    colorDominant: "#222222",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#820ad1",
      darken1: "#6b0193",
    },
    colorMainAppbg: {
      base: "#333333",
      darken1: "#111111",
    },
    colorBreadcrumbs: "#141414",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#bf15fe",
    colorOddSelectedText: "#000000",
    colorOddText: "#00ff00",
    primary: "#bf15fe",
    accent: "#00ff00",
  },
  esportepix: {
    colorDominant: "#444444",
    colorAppBar: "#834b9b",
    colorTabs: "#834b9b",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#31b32e",
      darken1: "#573267",
    },
    colorMainAppbg: {
      base: "#333333",
      darken1: "#111111",
    },
    colorBreadcrumbs: "#444444",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#834b9b",
    colorOddSelectedText: "#000000",
    colorOddText: "#ffffff",
    primary: "#48cf45",
    accent: "#00ff00",
  },
  lotbet: {
    colorDominant: "#585858",
    colorAppBar: "#046659",
    colorTabs: "#046659",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#383838",
      darken1: "#383838",
    },
    colorMainAppbg: {
      base: "#444444",
      darken1: "#333333",
    },
    colorBreadcrumbs: "#585858",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#046659",
    colorOddText: "#e4f90a",
    primary: "#c0cd36",
    accent: "#e4f90a",
  },
  sonhobet: {
    colorDominant: "#585858",
    colorAppBar: "#1e1e1e",
    colorTabs: "#cc0001",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#444444",
      darken1: "#444444",
    },
    colorMainAppbg: {
      base: "#383838",
      darken1: "#333333",
    },
    colorBreadcrumbs: "#585858",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#046659",
    colorOddText: "#ffdb01",
    primary: "#00e676",
    accent: "#ffdb01",
  },
  sonhobetcom: {
    colorDominant: "#585858",
    colorAppBar: "#cc0001",
    colorTabs: "#cc0001",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#444444",
      darken1: "#444444",
    },
    colorMainAppbg: {
      base: "#383838",
      darken1: "#333333",
    },
    colorBreadcrumbs: "#585858",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#046659",
    colorOddText: "#ffdb01",
    primary: "#00e676",
    accent: "#ffdb01",
  },
  betgames: {
    colorDominant: "#484848",
    colorAppBar: "#470080",
    colorTabs: "#470080",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#484848",
      darken1: "#484848",
    },
    colorMainAppbg: {
      base: "#555555",
      darken1: "#555555",
    },
    colorBreadcrumbs: "#383838",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#470080",
    colorOddText: "#ffffff",
    primary: "#3eb12f",
    accent: "#76ff03",
  },
  volpebet: {
    colorDominant: "#383838",
    colorAppBar: "#212121",
    colorTabs: "#212121",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#f4860d",
      darken1: "#282828",
    },
    colorMainAppbg: {
      base: "#555555",
      darken1: "#111111",
    },
    colorBreadcrumbs: "#383838",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#f4860d",
    colorOddText: "#ffffff",
    primary: "#f4860d",
    accent: "#ffea00",
  },
  volpe: {
    colorDominant: "#383838",
    colorAppBar: "#212121",
    colorTabs: "#212121",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#f4860d",
      darken1: "#282828",
    },
    colorMainAppbg: {
      base: "#555555",
      darken1: "#111111",
    },
    colorBreadcrumbs: "#383838",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#f4860d",
    colorOddText: "#ffffff",
    primary: "#f4860d",
    accent: "#ffea00",
  },
  tikbet: {
    colorDominant: "#3f6421",
    colorAppBar: "#000F4B",
    colorTabs: "#000F4B",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#80B404",
      darken1: "#000F4B",
    },
    colorMainAppbg: {
      base: "#555555",
      darken1: "#555555",
    },
    colorBreadcrumbs: "#383838",
    colorOddSelected: {
      base: "#97b836",
      darken1: "#97b836",
    },
    colorOddSelectedBorder: "#97b836",
    colorOddSelectedText: "#ffffff",
    colorOddText: "#ffffff",
    primary: "#97b836",
    accent: "#ffea00",
  },
  flashpix: {
    colorDominant: "#484848",
    colorAppBar: "#280808",
    colorTabs: "#280808",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#ca0000",
      darken1: "#280808",
    },
    colorMainAppbg: {
      base: "#212121",
      darken1: "#212121",
    },
    colorBreadcrumbs: "#383838",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#97b836",
    colorOddSelectedText: "#280808",
    colorOddText: "#ffffff",
    primary: "#cb9500",
    accent: "#ffea00",
  },
  esportenet: {
    colorDominant: "#3b3b3b",
    colorAppBar: "#b4510d",
    colorTabs: "#b4510d",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#222222",
      darken1: "#111111",
    },
    colorMainAppbg: {
      base: "#212121",
      darken1: "#212121",
    },
    colorBreadcrumbs: "#383838",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#111111",
    colorOddText: "#ffbd00",
    primary: "#ffbd00",
    accent: "#ffea00",
  },
  planetbet: {
    colorDominant: "#1e0359",
    colorAppBar: "#291d5f",
    colorTabs: "#291d5f",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#36dd69",
      darken1: "#1e0359",
    },
    colorMainAppbg: {
      base: "#333333",
      darken1: "#111111",
    },
    colorBreadcrumbs: "#1e0359",
    colorOddSelected: {
      base: "#20c051",
      darken1: "#20c051",
    },
    colorOddSelectedBorder: "#20c051",
    colorOddSelectedText: "#ffffff",
    colorOddText: "#77e89a",
    primary: "#20c051",
    accent: "#66dcd2",
  },
  betina123: {
    colorDominant: "#0c2d5b",
    colorAppBar: "#154f9f",
    colorTabs: "#154f9f",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#fabc37",
      darken1: "#0f3972",
    },
    colorMainAppbg: {
      base: "#092245",
      darken1: "#06172e",
    },
    colorOddSelected: {
      base: "#fabc37",
      darken1: "#fabc37",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#2d3a86",
    colorOddText: "#fabc37",
    primary: "#fabc37 ",
    accent: "#D9AA52",
  },
  caixabets: {
    colorDominant: "#002466",
    colorAppBar: "#003699",
    colorTabs: "#003699",
    carouselbg: "001b4d",
    colorMenuLeft: {
      base: "#f60909",
      darken1: "#002466",
    },
    colorMainAppbg: {
      base: "#001233",
      darken1: "#001233",
    },
    colorBreadcrumbs: "#001233",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#003699",
    colorOddText: "#ffffff",
    primary: "#f60909",
    accent: "#ffffff",
  },
  podersports: {
    colorDominant: "#383838",
    colorAppBar: "#000011",
    colorTabs: "#000011",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#0000b3",
      darken1: "#00001a",
    },
    colorMainAppbg: {
      base: "#333333",
      darken1: "#111111",
    },
    colorBreadcrumbs: "#212121",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#00314a",
    colorOddText: "#ffd82b",
    primary: "#ff0000",
    accent: "#76ffff",
  },
  panibet: {
    colorDominant: "#45464c",
    colorAppBar: "#0f1782",
    colorTabs: "#0f1782",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#ffd82b",
      darken1: "#0f1782",
    },
    colorMainAppbg: {
      base: "#040727",
      darken1: "#0D0D0D",
    },
    colorOddSelected: {
      base: "#ffd82b",
      darken1: "#ffd82b",
    },
    colorOddSelectedBorder: "#ffd82b",
    colorOddSelectedText: "#0f1782",
    colorOddText: "ffd311",
    primary: "#f7ca00",
    accent: "#ffd311",
  },
  recpix: {
    colorDominant: "#313131",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#ffcb00",
      darken1: "#111111",
    },
    colorMainAppbg: {
      base: "#222222",
      darken1: "#000000",
    },
    // colorToolBarMarkets: "#3a3c3e", // opcional
    // colorTable: "#3a3c3e", // opcional
    colorBreadcrumbs: "#000000",
    colorOddSelected: {
      base: "#ffcb00",
      darken1: "#ffcb00",
    },
    colorOddSelectedBorder: "#ffcb00",
    colorOddSelectedText: "#000000",
    colorOddText: "ffcb00",
    primary: "#ffcb00",
    accent: "#40cf71",
  },
  pagamaissports: {
    colorDominant: "#3b3b3b",
    colorAppBar: "#003300",
    colorTabs: "#003300",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#29b125",
      darken1: "#111111",
    },
    colorMainAppbg: {
      base: "#212121",
      darken1: "#212121",
    },
    colorBreadcrumbs: "#383838",
    // colorOddText: '#FFFF00',
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#8cdd21",
    colorOddSelectedText: "#6b8d3e",
    primary: "#8ad12d",
    accent: "#FFFF00",
  },
  oxebet: {
    colorDominant: "#383838",
    colorAppBar: "#312287",
    colorTabs: "#312287",
    carouselbg: "404040",
    colorMenuLeft: {
      base: "#0081ff",
      darken1: "#312287",
    },
    colorMainAppbg: {
      base: "#222222",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#404040",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#212121",
    colorOddText: "#ffffff",
    primary: "#0081ff",
    accent: "#ffe418",
  },
  zep: {
    colorDominant: "#333333",
    colorAppBar: "#1e1e1e",
    colorTabs: "#1e1e1e",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#0ed8c5",
      darken1: "#1e1e1e",
    },
    colorBreadcrumbs: "#212121",
    colorMainAppbg: {
      base: "#404040",
      darken1: "#404040",
    },
    colorOddSelected: {
      base: "#0ed8c5",
      darken1: "#0ed8c5",
    },
    colorOddSelectedBorder: "#0ed8c5",
    colorOddSelectedText: "#000000",
    primary: "#0ed8c5",
    accent: "#0ed8c5",
  },
  chutebet: {
    colorDominant: "#585858",
    colorAppBar: "#002d7c",
    colorTabs: "#002d7c",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#ffea00",
      darken1: "#2e7d32",
    },
    colorBreadcrumbs: "#1e376d",
    colorMainAppbg: {
      base: "#1b2d37",
      darken1: "#000a1b",
    },
    colorOddSelected: {
      base: "#00ea4e",
      darken1: "#00ea4e",
    },
    colorOddSelectedBorder: "#37ff7a",
    colorOddSelectedText: "#002d7c",
    colorOddText: '#04ff58',
    primary: "#00d045",
    accent: "#00dbff",
  },
  betdasorte: {
    colorDominant: "#585858",
    colorAppBar: "#05589b",
    colorTabs: "#05589b",
    carouselbg: "#212121",
    colorBreadcrumbs: "#585858",
    colorMenuLeft: {
      base: "#383838",
      darken1: "#383838",
    },
    colorMainAppbg: {
      base: "#444444",
      darken1: "#333333",
    },
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#05589b",
    colorOddText: "#ffdf1b",
    primary: "#f6ba28",
    accent: "#ffffff",
  },
  nubet: {
    colorDominant: "#3c0560",
    colorAppBar: "#3c0560",
    colorTabs: "#3c0560",
    carouselbg: "212121",
    colorBreadcrumbs: "#3c0560",
    colorMenuLeft: {
      base: "#c06df7",
      darken1: "#3c0560",
    },
    colorMainAppbg: {
      base: "#695675",
      darken1: "#6a517a",
    },
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ca85f9",
    colorOddSelectedText: "#3c0560",
    primary: "#d59dfa",
    accent: "#ffffff",
  },
  pixsorte: {
    colorDominant: "#505050",
    colorAppBar: "#08503a",
    colorTabs: "#101010",
    carouselbg: "#212121",
    colorBreadcrumbs: "#505050",
    colorMenuLeft: {
      base: "#abe264",
      darken1: "#08503a",
    },
    colorMainAppbg: {
      base: "#010b08",
      darken1: "#010b08",
    },
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#0e7e5a",
    colorOddText: "#8dff8d",
    primary: "#7abd23",
    accent: "#ffdf1b",
  },
  radarbets: {
    colorDominant: "#101010",
    colorAppBar: "#005000",
    colorTabs: "#005000",
    carouselbg: "#101010",
    colorBreadcrumbs: "#101010",
    colorMenuLeft: {
      base: "#101010",
      darken1: "#101010",
    },
    colorMainAppbg: {
      base: "#1E1E1E",
      darken1: "#1E1E1E",
    },
    colorOddSelected: {
      base: "#55BE10",
      darken1: "#55BE10",
    },
    colorOddSelectedBorder: "#55BE10",
    colorOddSelectedText: "#101010",
    colorOddText: "#55FF10",
    primary: "#55CE10",
    accent: "#55CE10",
  },
  kbet: {
    colorDominant: "#383838",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorBreadcrumbs: "212121",
    colorMenuLeft: {
      base: "#ea4e1c",
      darken1: "#000000",
    },
    colorMainAppbg: {
      base: "#222222",
      darken1: "#111111",
    },
    colorOddSelected: {
      base: "#ea4e1c",
      darken1: "#ea4e1c",
    },
    colorOddSelectedBorder: "#ea4e1c",
    colorOddSelectedText: "#ffffff",
    colorOddText: "#ffffff",
    primary: "#ea4e1c",
    accent: "#ffdf1b",
  },
  goldebet: {
    colorDominant: "#484848",
    colorAppBar: "#262424",
    colorTabs: "#262424",
    carouselbg: "484848",
    colorBreadcrumbs: "484848",
    colorMenuLeft: {
      base: "#fa800e",
      darken1: "#262424",
    },
    colorMainAppbg: {
      base: "#161414",
      darken1: "#161414",
    },
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#db812d",
    colorOddText: "#f9f906",
    primary: "#fa800e",
    accent: "#ffdf1b",
  },
  bet24hs: {
    colorDominant: "#11400a",
    colorAppBar: "#011906",
    colorTabs: "#011906",
    carouselbg: "#11400a",
    colorMenuLeft: {
      base: "#11400a",
      darken1: "#001a00",
    },
    colorMainAppbg: {
      base: "#11400a",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#11400a",
    colorOddSelected: {
      base: "#f9ff00",
      darken1: "#f9ff00",
    },
    colorOddSelectedBorder: "#f9ff00",
    colorOddSelectedText: "#00431f",
    colorOddText: "#f9ff00",
    primary: "#00d43c",
    accent: "#f9ff00",
  },
  deboa: {
    colorDominant: "#585858",
    colorAppBar: "#250089",
    colorTabs: "#250089",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#444444",
      darken1: "#444444",
    },
    colorMainAppbg: {
      base: "#383838",
      darken1: "#333333",
    },
    colorBreadcrumbs: "#585858",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#FF9C00",
    colorOddSelectedText: "#250089",
    colorOddText: "#ffffff",
    primary: "#FF9C00",
    accent: "#66dcd2",
  },
  arenas: {
    colorDominant: "#383838",
    colorAppBar: "#111111",
    colorTabs: "#111111",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#7be800",
      darken1: "#111111",
    },
    colorMainAppbg: {
      base: "#111111",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#212121",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#000000",
    colorOddText: '7be800',
    primary: "#7be800",
    accent: "#00ff66",
  },
  bateubet: {
    colorDominant: "#333333",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#00a600",
      darken1: "#000d00",
    },
    colorMainAppbg: {
      base: "#333333",
      darken1: "#111111",
    },
    colorBreadcrumbs: "#050402",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#000000",
    colorOddText: "#8dff8d",
    primary: "#00f300",
    accent: "#ffff00",
  },
  betfolia: {
    colorDominant: "#004c90",
    colorAppBar: "#0067C3",
    colorTabs: "#0067C3",
    carouselbg: "#122841",
    colorMenuLeft: {
      base: "#0067C3",
      darken1: "#122841",
    },
    colorMainAppbg: {
      base: "#383838",
      darken1: "#383838",
    },
    colorBreadcrumbs: '#004c90',
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#9df70c",
    colorOddSelectedText: "#122841",
    colorOddText: '#9df70c',
    primary: '#22d52f',
    accent: '#9DF70C#',
  },
  '18kbetonline': {
    colorDominant: "#101010",
    colorAppBar: "#101010",
    colorTabs: "#101010",
    carouselbg: "#101010",
    colorMenuLeft: {
      base: "#bf8701",
      darken1: "#101010",
    },
    colorMainAppbg: {
      base: "#101010",
      darken1: "#101010",
    },
    colorBreadcrumbs: '#292929',
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#fdd615  ",
    colorOddSelectedText: "#101010",
    colorOddText: '#fdd615',
    primary: '#c3a302',
    accent: '#00c420#',
  },
  modobet: {
    colorDominant: "#13376f",
    colorAppBar: "#13376f",
    colorTabs: "#13376f",
    carouselbg: "#1b4d9a",
    colorMenuLeft: {
      base: "#14aeda",
      darken1: "#13376f",
    },
    colorMainAppbg: {
      base: "#1b4d9a",
      darken1: "#1b4d9a",
    },
    colorBreadcrumbs: '#13376f',
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#14aeda  ",
    colorOddSelectedText: "#101010",
    colorOddText: '#c1edf9',
    primary: '#14aeda',
    accent: '#ffea00#',
  },
  pixlive: {
    colorDominant: "#13376f",
    colorAppBar: "#1b4d9a",
    colorTabs: "#1b4d9a",
    carouselbg: "#1b4d9a",
    colorMenuLeft: {
      base: "#14aeda",
      darken1: "#13376f",
    },
    colorMainAppbg: {
      base: "#08172e",
      darken1: "#08172e",
    },
    colorBreadcrumbs: '#13376f',
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#14aeda",
    colorOddSelectedText: "#08172e",
    colorOddText: '#c1edf9',
    primary: '#fec200',
    accent: '#fec200',
  },
  nbet91: {
    colorDominant: "#006e49",
    colorAppBar: "#0a3424",
    colorTabs: "#0a3424",
    carouselbg: "#005438",
    colorMenuLeft: {
      base: "#006e49",
      darken1: "#0a3424",
    },
    colorMainAppbg: {
      base: "#162821",
      darken1: "#101010",
    },
    colorBreadcrumbs: '#0a3424',
    colorOddSelected: {
      base: "#0a3424",
      darken1: "#0a3424",
    },
    colorOddSelectedBorder: "#faf268",
    colorOddSelectedText: "#faf268",
    colorOddText: '#faf268',
    primary: '#dcd007',
    accent: '#F9EE36',
  },
  betsmoney: {
    colorDominant: "#003b83",
    colorAppBar: "#00469d",
    colorTabs: "#00469d",
    carouselbg: "#1b4d9a",
    colorMenuLeft: {
      base: "#0068ea",
      darken1: "#040c18",
    },
    colorMainAppbg: {
      base: "#040c18",
      darken1: "#040c18",
    },
    colorBreadcrumbs: '#00469d',
    colorOddSelected: {
      base: "#fccc4c",
      darken1: "#f7b504",
    },
    colorOddSelectedBorder: "#fccc4c",
    colorOddSelectedText: "#040c18",
    colorOddText: '#ffffff',
    primary: '#fccc4c',
    accent: '#fccc4c',
  },
  cassinokingbet: {
    colorDominant: "#004d10",
    colorAppBar: "#004900",
    colorTabs: "#004900",
    carouselbg: "#001a00",
    colorMenuLeft: {
      base: "#00ff34",
      darken1: "#004900",
    },
    colorMainAppbg: {
      base: "#103910",
      darken1: "#183118",
    },
    colorBreadcrumbs: '#001a00',
    colorOddSelected: {
      base: "#004900",
      darken1: "#002f00",
    },
    colorOddSelectedBorder: "#ffda00  ",
    colorOddSelectedText: "#ffffff",
    colorOddText: '#f2f2f2',
    primary: '#ccae00',
    accent: '#ffda00#',
  },
  jogano: {
    colorDominant: "#6f6f6f",
    colorAppBar: "#0a2f4b",
    colorTabs: "#282828",
    carouselbg: "#282828",
    colorMenuLeft: {
      base: "#383838",
      darken1: "#383838",
    },
    colorMainAppbg: {
      base: "#494949",
      darken1: "#494949",
    },
    colorBreadcrumbs: '#282828',
    colorOddSelected: {
      base: "#0a2f4b",
      darken1: "#0a2f4b",
    },
    colorOddSelectedBorder: "#0a2f4b",
    colorOddSelectedText: "#ffffff",
    colorOddText: '#ffffff',
    primary: '#5bb4f9',
    accent: '#FFD700',
  },
  plane: {
    colorDominant: "#494949",
    colorAppBar: "#282828",
    colorTabs: "#494949",
    carouselbg: "#1f1400",
    colorMenuLeft: {
      base: "#d28500",
      darken1: "#101010",
    },
    colorMainAppbg: {
      base: "#101010",
      darken1: "#101010",
    },
    colorBreadcrumbs: '#494949',
    colorOddSelected: {
      base: "#ffa405",
      darken1: "#ffa405",
    },
    colorOddSelectedBorder: "#ffad1f",
    colorOddSelectedText: "#1f1400",
    colorOddText: "#ffffff",
    primary: '#3e765e',
    accent: '#ffad1f',
  },
  mandala: {
    colorDominant: "#00451c",
    colorAppBar: "#002c11",
    colorTabs: "#002c11",
    carouselbg: "#2b2207",
    colorMenuLeft: {
      base: "#dfb239",
      darken1: "#011d0d",
    },
    colorMainAppbg: {
      base: "#101010",
      darken1: "#011d0d",
    },
    colorBreadcrumbs: '#002c11',
    colorOddSelected: {
      base: "#ffa405",
      darken1: "#ffa405",
    },
    colorOddSelectedBorder: "#ffad1f",
    colorOddSelectedText: "#002c11",
    colorOddText: '#002c11',
    primary: '#fcbf1c',
    accent: '#ffad1f',
  },
  betgol777: {
    colorDominant: "#111f21",
    colorAppBar: "#111f21",
    colorTabs: "#111f21",
    carouselbg: "#111f21",
    colorMenuLeft: {
      base: "#00805b",
      darken1: "#111f21",
    },
    colorMainAppbg: {
      base: "#1d1d1d",
      darken1: "#011d0d",
    },
    colorBreadcrumbs: "#2b4e53",
    colorOddSelected: {
      base: "#f58b1e",
      darken1: "#f58b1e",
    },
    colorOddSelectedBorder: "#f58b1e",
    colorOddSelectedText: "#011d0d",
    colorOddText: "#e5fff8",
    primary: "#00ffb6",
    accent: "#f7a44f",
  },
  bbsesportes: {
    colorDominant: "#12467b",
    colorAppBar: "#002d5a",
    colorTabs: "#002d5a",
    carouselbg: "#111f21",
    colorMenuLeft: {
      base: "#0053a6",
      darken1: "#001327",
    },
    colorMainAppbg: {
      base: "#1d1d1d",
      darken1: "#001327",
    },
    colorBreadcrumbs: "#12467b",
    colorOddSelected: {
      base: "#00cc92",
      darken1: "#00cc92",
    },
    colorOddSelectedBorder: "#00cc92",
    colorOddSelectedText: "#011d0d",
    colorOddText: "#e5fff8",
    primary: "#00ffb6",
    accent: "#f7a44f",
  },
  tudobets: {
    colorDominant: "#00792a",
    colorAppBar: "#002d10",
    colorTabs: "#002d10",
    carouselbg: "#111f21",
    colorMenuLeft: {
      base: "#009333",
      darken1: "#111f21",
    },
    colorMainAppbg: {
      base: "#696969",
      darken1: "#011d0d",
    },
    colorBreadcrumbs: "#002d10",
    colorOddSelected: {
      base: "#002d10",
      darken1: "#002d10",
    },
    colorOddSelectedBorder: "#002d10",
    colorOddSelectedText: "#c6ffda",
    colorOddText: "#e5fff8",
    primary: "#13ff65",
    accent: "#c6ffda",
  },
  '25bet': {
    colorDominant: "#014936",
    colorAppBar: "#013023",
    colorTabs: "#013023",
    carouselbg: "#101010",
    colorMenuLeft: {
      base: "#027b5b",
      darken1: "#014936",
    },
    colorMainAppbg: {
      base: "#101010",
      darken1: "#050201",
    },
    colorBreadcrumbs: "#013023",
    colorOddSelected: {
      base: "#34fcc7",
      darken1: "#34fcc7",
    },
    colorOddSelectedBorder: "#34fcc7",
    colorOddSelectedText: "#001711",
    colorOddText: "#fbf1f0",
    primary: "#ffc600",
    accent: "#34fcc7",
  },
  overbets: {
    colorDominant: "#233444",
    colorAppBar: "#131A22",
    colorTabs: "#131A22",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#00B944",
      darken1: "#192732",
    },
    colorBreadcrumbs: "#192732",
    colorMainAppbg: {
      base: "#090E11",
      darken1: "#090E11",
    },
    colorOddSelected: {
      base: "#00c400",
      darken1: "#00c400",
    },
    colorOddSelectedBorder: "#00c400",
    colorOddSelectedText: "#ffffff",
    colorOddText: '#00FB4D',
    primary: "#00B944",
    accent: "#00B944",
  },
  revybet: {
    colorDominant: "#171b4f",
    colorAppBar: "#1f2247",
    colorTabs: "#1f2247",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#101123",
      darken1: "#101123",
    },
    colorBreadcrumbs: "#1f2247",
    colorMainAppbg: {
      base: "#111111",
      darken1: "#101123",
    },
    colorOddSelected: {
      base: "#74e52d",
      darken1: "#74e52d",
    },
    colorOddSelectedBorder: "#74e52d",
    colorOddSelectedText: "#101123",
    colorOddText: '#91ff91',
    primary: "#83e844",
    accent: "#83e844",
  },
  sheik: {
    colorDominant: "#7f612d",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#dfbd69",
      darken1: "#6c5227",
    },
    colorBreadcrumbs: "#5F4922",
    colorMainAppbg: {
      base: "#c19851",
      darken1: "#6c5227",
    },
    colorOddSelected: {
      base: "#29000a",
      darken1: "#29000a",
    },
    colorOddSelectedBorder: "#29000a",
    colorOddSelectedText: "#f6cb17",
    colorOddText: '#29000a',
    primary: "#f6cb17",
    accent: "#e4c029",
  },
  betdosfamosos: {
    colorDominant: "#393944",
    colorAppBar: "#901c25",
    colorTabs: "#901c25",
    carouselbg: "#393944",
    colorMenuLeft: {
      base: "#2d2d36",
      darken1: "#2d2d36",
    },
    colorBreadcrumbs: "#a5212b",
    colorMainAppbg: {
      base: "#222228",
      darken1: "#212121",
    },
    colorOddSelected: {
      base: "#ff881d",
      darken1: "#ff881d",
    },
    colorOddSelectedBorder: "#ff881d",
    colorOddSelectedText: "#65141a",
    colorOddText: '#ffcb9c',
    primary: "#ff881d",
    accent: "#ff881d",
  },
  betzilla: {
    colorDominant: "#302f30",
    colorAppBar: "#3D1463",
    colorTabs: "#3D1463",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#302f30",
      darken1: "#302f30",
    },
    colorMainAppbg: {
      base: "#161616",
      darken1: "#161616",
    },
    colorBreadcrumbs: "#3D1463",
    colorOddSelected: {
      base: "#8a3bd7",
      darken1: "#8a3bd7",
    },
    colorOddSelectedBorder: "#8a3bd7",
    colorOddSelectedText: "#ffffff",
    colorOddText: "#ffffff",
    primary: "#ff4781",
    accent: "#ff4781",
  },
  bolladasorte: {
    colorDominant: "#00408c",
    colorAppBar: "#001d40",
    colorTabs: "#001d40",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#00408c",
      darken1: "#001d40",
    },
    colorMainAppbg: {
      base: "#001126",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#00408c",
    colorOddSelected: {
      base: "#2caaff",
      darken1: "#2caaff",
    },
    colorOddSelectedBorder: "#45b4ff",
    colorOddSelectedText: "#ffffff",
    colorOddText: "#ffffff",
    primary: "#2caaff",
    accent: "#2caaff",
  },
  lottomaster: {
    colorDominant: "#00408c",
    colorAppBar: "#001d40",
    colorTabs: "#001d40",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#00408c",
      darken1: "#001d40",
    },
    colorMainAppbg: {
      base: "#001126",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#00408c",
    colorOddSelected: {
      base: "#ff6600",
      darken1: "#ff6600",
    },
    colorOddSelectedBorder: "#ff6600",
    colorOddSelectedText: "#ffffff",
    colorOddText: "#ffffff",
    primary: "#ff6600",
    accent: "#0071bc",
  },
  trevosports: {
    colorDominant: "#002b00",
    colorAppBar: "#002b00",
    colorTabs: "#002b00",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#007700",
      darken1: "#001100",
    },
    colorMainAppbg: {
      base: "#212121",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#3a3a3a",
    colorOddSelected: {
      base: "#00c400",
      darken1: "#00c400",
    },
    colorOddSelectedBorder: "#00c400",
    colorOddSelectedText: "#ffffff",
    colorOddText: "#ffffff",
    primary: "#00c400",
    accent: "#0071bc",
  },
  camisa9: {
    colorDominant: "#3D1463",
    colorAppBar: "#160723",
    colorTabs: "#3D1463",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#3D1463",
      darken1: "#3D1463",
    },
    colorMainAppbg: {
      base: "#212121",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#160723",
    colorOddSelected: {
      base: "#d6b8f1",
      darken1: "#d6b8f1",
    },
    colorOddSelectedBorder: "#d6b8f1",
    colorOddSelectedText: "#160723",
    colorOddText: "#ffffff",
    primary: "#b160fc",
    accent: "#b160fc",
  },
  lanceesportivo: {
    colorDominant: "#1f2747",
    colorAppBar: "#000a33",
    colorTabs: "#000a33",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#001566",
      darken1: "#00051a",
    },
    colorMainAppbg: {
      base: "#141414",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#000a33",
    colorOddSelected: {
      base: "#d10708",
      darken1: "#d10708",
    },
    colorOddSelectedBorder: "#d10708",
    colorOddSelectedText: "#ffffff",
    colorOddText: "#ffffff",
    primary: "#e52627",
    accent: "#d10708",
  },
  donosdabola: {
    colorDominant: "#383838",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#ff6500",
      darken1: "#000000",
    },
    colorMainAppbg: {
      base: "#333333",
      darken1: "#111111",
    },
    colorBreadcrumbs: "#000000",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ff6500",
    colorOddSelectedText: "#000000",
    colorOddText: "#ffffff",
    primary: "#ff6500",
    accent: "#ff6500",
  },
  sbet355: {
    colorDominant: "#383838",
    colorAppBar: "#00815d",
    colorTabs: "#00815d",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#333333",
      darken1: "#333333",
    },
    colorMainAppbg: {
      base: "#333333",
      darken1: "#111111",
    },
    colorBreadcrumbs: "#00815d",
    colorOddSelected: {
      base: "#ffe701",
      darken1: "#ffe701",
    },
    colorOddSelectedBorder: "#ffe701",
    colorOddSelectedText: "#000000",
    colorOddText: "#ffe701",
    primary: "#e6d21a",
    accent: "#9affe3",
  },
  placax: {
    colorDominant: "#212121",
    colorAppBar: "#444444",
    colorTabs: "#444444",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#e65a00",
      darken1: "#444444",
    },
    colorMainAppbg: {
      base: "#444444",
      darken1: "#212121",
    },
    colorBreadcrumbs: "#212121",
    colorOddSelected: {
      base: "#FF6400",
      darken1: "#FF6400",
    },
    colorOddSelectedBorder: "#FF6400",
    colorOddSelectedText: "#000000",
    colorOddText: "#ffffff",
    primary: "#FF6400",
    accent: "#FF6400",
  },
  sabiobet: {
    colorDominant: "#212121",
    colorAppBar: "#6F0C10",
    colorTabs: "#6F0C10",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#6F0C10",
      darken1: "#000000",
    },
    colorMainAppbg: {
      base: "#212121",
      darken1: "#212121",
    },
    colorBreadcrumbs: "#212121",
    colorOddSelected: {
      base: "#fe4e4e",
      darken1: "#fe4e4e",
    },
    colorOddSelectedBorder: "#fe4e4e",
    colorOddSelectedText: "#000000",
    colorOddText: "#ffe6e6",
    primary: "#fe4e4e",
    accent: "#fe4e4e",
  },
  placarxbet: {
    colorDominant: "#212121",
    colorAppBar: "#444444",
    colorTabs: "#444444",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#e65a00",
      darken1: "#444444",
    },
    colorMainAppbg: {
      base: "#444444",
      darken1: "#212121",
    },
    colorBreadcrumbs: "#212121",
    colorOddSelected: {
      base: "#FF6400",
      darken1: "#FF6400",
    },
    colorOddSelectedBorder: "#FF6400",
    colorOddSelectedText: "#000000",
    colorOddText: "#ffffff",
    primary: "#FF6400",
    accent: "#FF6400",
  },
  lancebet: {
    colorDominant: "#3a3a3a",
    colorAppBar: "#002761",
    colorTabs: "#002761",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#005be1",
      darken1: "#002761",
    },
    colorMainAppbg: {
      base: "#4e4e4e",
      darken1: "#212121",
    },
    colorBreadcrumbs: "#002761",
    colorOddSelected: {
      base: "#ffd203",
      darken1: "#ffd203",
    },
    colorOddSelectedBorder: "#ffd203",
    colorOddSelectedText: "#00317b",
    colorOddText: "#fff2b5",
    primary: "#e8bf00",
    accent: "#e8bf00",
  },
  streetbet: {
    colorDominant: "#212121",
    colorAppBar: "#141414",
    colorTabs: "#141414",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#EB0C0C",
      darken1: "#141414",
    },
    colorMainAppbg: {
      base: "#303030",
      darken1: "#212121",
    },
    colorBreadcrumbs: "#141414",
    colorOddSelected: {
      base: "#E8BF00",
      darken1: "#E8BF00",
    },
    colorOddSelectedBorder: "#E8BF00",
    colorOddSelectedText: "#212121",
    colorOddText: "#FCE9E9",
    primary: "#EB0C0C",
    accent: "#E8BF00",
  },
  dubaibet: { // zero1bet
    colorDominant: "#212121",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#00FF00",
      darken1: "#141414",
    },
    colorMainAppbg: {
      base: "#303030",
      darken1: "#212121",
    },
    colorBreadcrumbs: "#141414",
    colorOddSelected: {
      base: "#00FF00",
      darken1: "#00FF00",
    },
    colorOddSelectedBorder: "#FFFFFF",
    colorOddSelectedText: "#141414",
    colorOddText: "#FCE9E9",
    primary: "#00CC00",
    accent: "#00FF00",
  },
  pixcerto: { 
    colorDominant: "#000063",
    colorAppBar: "#000031",
    colorTabs: "#000031",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#000063",
      darken1: "#000017",
    },
    colorMainAppbg: {
      base: "#0000c9",
      darken1: "#000031",
    },
    colorBreadcrumbs: "#00004a",
    colorOddSelected: {
      base: "#FFC700",
      darken1: "#FFC700",
    },
    colorOddSelectedBorder: "#FFC700",
    colorOddSelectedText: "#141414",
    colorOddText: "#fff9e5",
    primary: "#FFC700",
    accent: "#FFC700",
  },
  betdosertao: {
    colorDominant: "#3a3a3a",
    colorAppBar: "#306e46",
    colorTabs: "#193924",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#63bb82",
      darken1: "#193924",
    },
    colorMainAppbg: {
      base: "#4e4e4e",
      darken1: "#212121",
    },
    colorBreadcrumbs: "#193924",
    colorOddSelected: {
      base: "#F9BD39",
      darken1: "#F9BD39",
    },
    colorOddSelectedBorder: "#F9BD39",
    colorOddSelectedText: "#193924",
    colorOddText: "#fff2b5",
    primary: "#F9BD39",
    accent: "#F9BD39",
  },
  bestgameitabuna: {
    colorDominant: "#383838",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#FF7C00",
      darken1: "#111111",
    },
    colorMainAppbg: {
      base: "#111111",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#212121",
    colorOddSelected: {
      base: "#FF7C00",
      darken1: "#FF7C00",
    },
    colorOddSelectedBorder: "#FF7C00",
    colorOddSelectedText: "#000000",
    colorOddText: "#E4F90A",
    primary: "#FF7C00",
    accent: "#FFF500",
  },
  oficialbetgames: {
    colorDominant: "#001c3d",
    colorAppBar: "#001c3d",
    colorTabs: "#001c3d",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#001c3d",
      darken1: "#0F3AB1",
    },
    colorMainAppbg: {
      base: "#0F0F0F",
      darken1: "#111111",
    },
    colorBreadcrumbs: "#002857",
    colorOddSelected: {
      base: "#FFFFFF",
      darken1: "#FFFFFF",
    },
    colorOddSelectedBorder: "#FFFFFF",
    colorOddSelectedText: "#0F3AB1",
    colorOddText: "#FFFFFF",
    primary: "#678cf2",
    accent: "#70B2FF",
  },
  latano: {
    colorDominant: "#171b4f",
    colorAppBar: "#1f2247",
    colorTabs: "#1f2247",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#101123",
      darken1: "#101123",
    },
    colorBreadcrumbs: "#1f2247",
    colorMainAppbg: {
      base: "#111111",
      darken1: "#101123",
    },
    colorOddSelected: {
      base: "#58D531",
      darken1: "#58D531",
    },
    colorOddSelectedBorder: "#58D531",
    colorOddSelectedText: "#101123",
    colorOddText: '#91ff91',
    primary: "#58D531",
    accent: "#58D531",
  },
  g6games: {
    colorDominant: "#8A36E8",
    colorAppBar: "#392261",
    colorTabs: "#392261",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#F9B81D",
      darken1: "#392261",
    },
    colorMainAppbg: {
      base: "#0F0F0F",
      darken1: "#111111",
    },
    colorBreadcrumbs: "#392261",
    colorOddSelected: {
      base: "#F9B81D",
      darken1: "#F9B81D",
    },
    colorOddSelectedBorder: "#F9B81D",
    colorOddSelectedText: "#000000",
    colorOddText: "#EE9815",
    primary: "#F9B81D",
    accent: "#EE9815",
  },
  lotusbet: {
    colorDominant: "#333333",
    colorAppBar: "#035E2D",
    colorTabs: "#035E2D",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#73C330",
      darken1: "#022c15",
    },
    colorMainAppbg: {
      base: "#111111",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#0A6333",
    colorOddSelected: {
      base: "#A8DE7B",
      darken1: "#A8DE7B",
    },
    colorOddSelectedBorder: "#A8DE7B",
    colorOddSelectedText: "#0A6333",
    colorOddText: "#A8DE7B",
    primary: "#73C330",
    accent: "#73C330",
  },
  nordestefutebol: {
    colorDominant: "#2F4189",
    colorAppBar: "#222F63",
    colorTabs: "#222F63",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#2F4189",
      darken1: "#151D3D",
    },
    colorMainAppbg: {
      base: "#111111",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#2F4189",
    colorOddSelected: {
      base: "#F1EC99",
      darken1: "#F1EC99",
    },
    colorOddSelectedBorder: "#F1EC99",
    colorOddSelectedText: "#151D3D",
    colorOddText: "#F1EC99",
    primary: "#ECBB20",
    accent: "#EEC238",
  },
  betesportivo: {
    colorDominant: "#1e376d",
    colorAppBar: "#004a99",
    colorTabs: "#004a99",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#40be3b",
      darken1: "#004a99",
    },
    colorBreadcrumbs: "#1e376d",
    colorMainAppbg: {
      base: "#212121",
      darken1: "#080809",
    },
    colorOddSelected: {
      base: "#00931e",
      darken1: "#00931e",
    },
    colorOddSelectedBorder: "#76ff03",
    colorOddSelectedText: "#ffffff",
    colorOddText: '#76ff03',
    primary: "#64dd17",
    accent: "#ffff00",
  },
  boto: {
    colorDominant: "#0A3740",
    colorAppBar: "#0A3740",
    colorTabs: "#336666",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#0A3740",
      darken1: "#0A3740",
    },
    colorBreadcrumbs: "#0A3740",
    colorMainAppbg: {
      base: "#212121",
      darken1: "#0A3740",
    },
    colorOddSelected: {
      base: "#a9f04d",
      darken1: "#a9f04d",
    },
    colorOddSelectedBorder: "#a9f04d",
    colorOddSelectedText: "#0A3740",
    colorOddText: '#a9f04d',
    primary: "#53BA83 ",
    accent: "#FFCC00",
  },
  aki: {
    colorDominant: "#25084A",
    colorAppBar: "#44197C",
    colorTabs: "#25084A",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#366E8C",
      darken1: "#44197C",
    },
    colorBreadcrumbs: "#25084A",
    colorMainAppbg: {
      base: "#3B5888",
      darken1: "#3B5888",
    },
    colorOddSelected: {
      base: "#26D69F",
      darken1: "#26D69F",
    },
    colorOddSelectedBorder: "#26D69F",
    colorOddSelectedText: "#44197C",
    colorOddText: '#26D69F',
    primary: "#26D69F ",
    accent: "#26D69F",
  },
  coraesportes: {
    colorDominant: "#5800B0",
    colorAppBar: "#1C003A",
    colorTabs: "#1C003A",
    carouselbg: "#0A0015",
    colorMenuLeft: {
      base: "#88FF55",
      darken1: "#1C003A",
    },
    colorBreadcrumbs: "#320064",
    colorMainAppbg: {
      base: "#090015",
      darken1: "#090015",
    },
    colorOddSelected: {
      base: "#88FF55",
      darken1: "#88FF55",
    },
    colorOddSelectedBorder: "#88FF55",
    colorOddSelectedText: "#30015D",
    colorOddText: '#88FF55',
    primary: "#88FF55 ",
    accent: "#88FF55",
  },
  betvipsports: {
    colorDominant: "#1E3E39",
    colorAppBar: "#101010",
    colorTabs: "#08211D",
    carouselbg: "#212121",
    colorMenuLeft: {
      base: "#1E3E39",
      darken1: "#08211D",
    },
    colorBreadcrumbs: "#08211D",
    colorMainAppbg: {
      base: "#1A1A18",
      darken1: "#000000",
    },
    colorOddSelected: {
      base: "#C7AB6A",
      darken1: "#C59B39",
    },
    colorOddSelectedBorder: "#DCAC3B",
    colorOddSelectedText: "#08211D",
    colorOddText: '#EFDAA8',
    primary: "#DCAC3B",
    accent: "#279B89",
  },
  taky: {
    colorDominant: "#841D91",
    colorAppBar: "#600183",
    colorTabs: "#600183",
    carouselbg: "#122841",
    colorMenuLeft: {
      base: "#600183",
      darken1: "#600183",
    },
    colorMainAppbg: {
      base: "#383838",
      darken1: "#383838",
    },
    colorBreadcrumbs: '#600183',
    colorOddSelected: {
      base: "#F15B29",
      darken1: "#F15B29",
    },
    colorOddSelectedBorder: "#F15B29",
    colorOddSelectedText: "#122841",
    colorOddText: '#ffffff',
    primary: '#F15B29',
    accent: '#F15B29#',
  },
  attack: {
    colorDominant: "#0E427C",
    colorAppBar: "#10239C",
    colorTabs: "#10239C",
    carouselbg: "#122841",
    colorMenuLeft: {
      base: "#0E427C",
      darken1: "#10239C",
    },
    colorMainAppbg: {
      base: "#08172E",
      darken1: "#08172E",
    },
    colorBreadcrumbs: '#0E427C',
    colorOddSelected: {
      base: "#01C001",
      darken1: "#01C001",
    },
    colorOddSelectedBorder: "#01C001",
    colorOddSelectedText: "#122841",
    colorOddText: '#9DF70C',
    primary: '#01A701',
    accent: '#9DF70C#',
  },
  cuiababets: {
    colorDominant: "#333333",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "#000000",
    colorMenuLeft: {
      base: "#00A600",
      darken1: "#000D00",
    },
    colorMainAppbg: {
      base: "#333333",
      darken1: "#111111",
    },
    colorBreadcrumbs: '#000000',
    colorOddSelected: {
      base: "#00A600",
      darken1: "#00A600",
    },
    colorOddSelectedBorder: "#00A600",
    colorOddSelectedText: "#FFFFFF",
    colorOddText: '#8DFF8D',
    primary: '#00B900',
    accent: '#FFFF00#',
  },

  // ====================================== //
  // TEMAS GENÉRICOS (azul, vermelho, etc)
  // ====================================== //  
  sga: {
    colorDominant: "#585858",
    colorAppBar: "#37474f",
    colorTabs: "#37474f",
    colorMenuLeft: {
      base: "#383838",
      darken1: "#383838",
    },
    colorMainAppbg: {
      base: "#111111",
      darken1: "#111111",
    },
    colorBreadcrumbs: "#585858",
    colorOddSelected: {
      base: "#aeea00",
      darken1: "#aeea00",
    },
    colorOddSelectedBorder: "#aeea00",
    colorOddSelectedText: "#000000",
    colorOddText: "#ffea00",
    primary: "#aeea00",
    accent: "#ffc720",
  },
  blue: {
    colorDominant: "#686868",
    colorAppBar: "#1565c0",
    colorTabs: "#1565c0",
    carouselbg: "404040",
    colorMenuLeft: {
      base: "#383838",
      darken1: "#383838",
    },
    colorMainAppbg: {
      base: "#585858",
      darken1: "#585858",
    },
    colorBreadcrumbs: "#404040",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#212121",
    colorOddText: "#ffffff",
    primary: "#00e5ff",
    accent: "#ffe418",
  },
  blueRed: {
    colorDominant: "#021f3d",
    colorAppBar: "#05386f",
    colorTabs: "#05386f",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#086ad0",
      darken1: "#011224",
    },
    colorMainAppbg: {
      base: "#04386e",
      darken1: "#00060c",
    },
    colorBreadcrumbs: "#021f3d",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#000000",
    primary: "#f22828",
    accent: "#ede632",
  },
  blueGreen: {
    colorDominant: "#044999",
    colorAppBar: "#00499d",
    colorTabs: "#00499d",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#00c400",
      darken1: "#00499d",
    },
    colorBreadcrumbs: "#1e376d",
    colorMainAppbg: {
      base: "#212121",
      darken1: "#111111",
    },
    colorOddSelected: {
      base: "#00c400",
      darken1: "#00c400",
    },
    colorOddSelectedBorder: "#00c400",
    colorOddSelectedText: "#ffffff",
    // colorOddText: '#ffff00',
    primary: "#00c400",
    accent: "#ffff00",
  },
  blueDarkYellow: {
    colorDominant: "#04065d",
    colorAppBar: "#04065d",
    colorTabs: "#04065d",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#080ba6",
      darken1: "#02032c",
    },
    colorMainAppbg: {
      base: "#050875",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#02032c",
    colorOddSelected: {
      base: "#ffde00",
      darken1: "#b39b00",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#000000",
    primary: "#ccb200",
    accent: "#c3ae00",
  },
  blueGreyOrange: {
    colorDominant: "#325166",
    colorAppBar: "#315166",
    colorTabs: "#315166",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#df5614",
      darken1: "#315166",
    },
    colorMainAppbg: {
      base: "#383838",
      darken1: "#111111",
    },
    colorBreadcrumbs: "#203644",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#000000",
    primary: "#df5614",
    accent: "#ede632",
  },
  darkGreen: {
    colorDominant: "#444444",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorBreadcrumbs: "#212121",
    colorMenuLeft: {
      base: "#64dd17",
      darken1: "#000000",
    },
    colorMainAppbg: {
      base: "#444444",
      darken1: "#222222",
    },
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#33691e",
    colorOddText: "#ffffff",
    primary: "#64dd17",
    accent: "#ffea00",
  },
  darkRed: {
    colorDominant: "#444444",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorBreadcrumbs: "#212121",
    colorMenuLeft: {
      base: "#d50000",
      darken1: "#000000",
    },
    colorMainAppbg: {
      base: "#444444",
      darken1: "#222222",
    },
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#33691e",
    colorOddText: "#ffffff",
    primary: "#d50000",
    accent: "#ffea00",
  },
  darkYellow: {
    colorDominant: "#383838",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#ffab00",
      darken1: "#000000",
    },
    colorMainAppbg: {
      base: "#212121",
      darken1: "#080809",
    },
    colorBreadcrumbs: "#212121",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffab00",
    colorOddSelectedText: "#000000",
    colorOddText: "#ffea00",
    primary: "#ffab00",
    accent: "#fae748",
  },
  greenYellow: {
    colorDominant: "#003300",
    colorAppBar: "#006600",
    colorTabs: "#006600",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#baa700",
      darken1: "#001a00",
    },
    colorMainAppbg: {
      base: "#003300",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#001a00",
    colorOddSelected: {
      base: "#ffff00",
      darken1: "#ffff00",
    },
    colorOddSelectedBorder: "#877a00",
    colorOddSelectedText: "#000000",
    primary: "#edd500",
    accent: "#ede632",
  },
  redYellow: {
    colorDominant: "#484848",
    colorAppBar: "#b71c1c",
    colorTabs: "#b71c1c",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#383838",
      darken1: "#383838",
    },
    colorMainAppbg: {
      base: "#111111",
      darken1: "#111111",
    },
    colorBreadcrumbs: "#585858",
    colorOddText: '#f2e541',
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#f2e541",
    colorOddSelectedText: "#000000",
    primary: "#edab03",
    accent: "#FFFF00",
  },
  betsgame: {
    colorDominant: "#383838",
    colorAppBar: "#000000",
    colorTabs: "#000000",
    carouselbg: "212121",
    colorMenuLeft: {
      base: "#3faf77",
      darken1: "#111111",
    },
    colorMainAppbg: {
      base: "#111111",
      darken1: "#000000",
    },
    colorBreadcrumbs: "#212121",
    colorOddSelected: {
      base: "#ffffff",
      darken1: "#ffffff",
    },
    colorOddSelectedBorder: "#ffffff",
    colorOddSelectedText: "#31895d",
    colorOddText: "#e4f90a",
    primary: "#3faf77",
    accent: "#00ff66",
  },
};

let theme = {};
const client = domain();
const sga = ['demobet', 'goolgame', 'smsports', 'golbet', "777game", "bolanoangulo", "fezinha", "olimpicabets", "ecobets", "esportemaster", "bet500", "saobento", "futeboldasorte", "boaesporte", 'bolaoboaesporte'];
const blue = ['betmania', 'sportsbet765', 'sertaosports', "betmania", 'laliga'];
const darkYellow = ['apostagarantida', 'bolanarede10', 'golbet3', "bet77", 'bet3x', 'newbet', 'boladavez', 'top360', 'futeboldeouro', 'bet1000', 'goldeouro', 'malubet', 'apostapremium', 'futebolmania'];
const greenYellow = ['betvipmais', 'fortbets', 'ourodasortevip', 'playbrasil', 'boasorte', '88xbet', 'brasilbet', 'jogodeouro', 'boaesportebahia', 'arenaboaesporte', 'betbrasil', 'elitexbet'];
const blueRed = ['bolanarede', 'esportiva', 'tapajos', 'bolanaredebr', 'velhochico'];
const blueGreyOrange = ['superbets', 'superbetssertao', 'betinterativo', 'topsports', 'sortesua', 'pixbet88'];
const blueGreen = ['betinterativo'];
const redYellow = ['betsp', 'goltop', 'gigabets'];
const blueDarkYellow = ['betsprime', 'premierbet', 'topbets', '10xbet'];
const darkGreen = ['chutevale'];
const darkRed = ['spin'];
const betsGame = ['bestgameilheus', 'bestgameporto', 'bestgameteixeira'];

if (sga.includes(client)) {
  theme = themes['sga'];
} else if (blue.includes(client)) {
  theme = themes['blue'];
} else if (blueGreen.includes(client)) {
  theme = themes['blueGreen'];
} else if (darkYellow.includes(client)) {
  theme = themes['darkYellow'];
} else if (greenYellow.includes(client)) {
  theme = themes['greenYellow'];
} else if (blueRed.includes(client)) {
  theme = themes['blueRed'];
} else if (blueGreyOrange.includes(client)) {
  theme = themes['blueGreyOrange'];
} else if (redYellow.includes(client)) {
  theme = themes['redYellow'];
} else if (blueDarkYellow.includes(client)) {
  theme = themes['blueDarkYellow'];
} else if (darkGreen.includes(client)) {
  theme = themes['darkGreen'];
} else if (darkRed.includes(client)) {
  theme = themes['darkRed'];
} else if (betsGame.includes(client)) {
  theme = themes['betsgame'];
} else {
  theme = themes[client];
}

export default theme;
